import React, { useState, useEffect,useRef } from "react";
import {  fetchHiringRequests, fetchHiringManagers, GetDemandPlanning, fetchRolesForDepartment,saveHiringRequest,SaveHiringRequestStatus,UpdateIsConevrtToSource ,UpdateHiringRequest, fetchActiveDepartments } from "../services/apiService"; // Import the API service for roles
import Select from 'react-select';
import LoadingSpinner from '../components/LoadingSpinner';
import {   getDepartmentIdFromToken,getUserFromToken, getToken } from '../services/authService';
// In App.js or the main entry component
 
import { useMsal } from "@azure/msal-react";
 
import JobDescription from "../components/JobDescription";
import FlipCard from "../components/FlipCard";
import { SendApprovalEmailToHiringManagerAsync, SendSourcingAssignmentEmailAsync, SendApprovalWorkflowEmailAsync } from "../services/sendMailSMTP";
import { toast } from "react-hot-toast";
import CreateHiringRequestModal from "../components/CreateHiringRequestModal";

 


 
 const styles = {
  spinner: {
    border: '4px solid rgba(18, 76, 114, 0.1)',
    borderLeftColor: 'rgb(18, 76, 114)',
    borderRadius: '50%',
    width: '40px',
    height: '40px',
    animation: 'spin 1s linear infinite'
  },
  errorContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '400px',
    padding: '2rem',
    textAlign: 'center'
  }
};

const keyframes = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;
 

// Main HiringPage component
const HiringPage = () => {
  const [hiringRequests, setHiringRequests] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [hiringManagers, setHiringManagers] = useState([]);
  const [rolesForDepartment, setRolesForDepartment] = useState([]);
 
  const [DemandPlanning, setDemandPlanning] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedDepartment, setSelectedDepartment] = useState("all");
  const [selectedHiringManager, setSelectedHiringManager] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState('all');  // 'all' means no specific status selected
  const [selectedSourcing, setSelectedSourcing] = useState('all'); // Default is 'all'
 
  const [isApprovalChecked, setIsApprovalChecked] = useState(false);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
 
 const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  
  const [newRequest, setNewRequest] = useState({
    department_id: "",
    job_description: "",
    job_description_file: "",
    hiring_manager: "",
    position:"",
     positionForcast:"",
    positionExeptional:"",
    reason_for_hire: "",
    planned_start_date: "",
    status: "",
    priority: "",
    position_type: "",
    hiring_Type: "",
    preferred_requirment:"",
    demand_id:"0",
    created_by: "",
    role_text:"",
    request_type:"",
    companyCode:"",
    years:new Date().getFullYear(),
     IsDepartmentRestricted:"",
     IsFinanceManagerApproveRequired:"",
     Documents: {
        FileName: "",
        FileBase64: "",
        Size: 0,
        MimeType: "",
        reference_id: "0",
        process_type: "",
        uploaded_by: "",
        uploaded_at: "", // or null if you're using Date object
        IsActive: true
      }
  });


  const [selectedRequest, setSelectedRequest] = useState(null); // Track selected request
  const [isModalVisible, setIsModalVisible] = useState(false); // Control modal visibility
  const [isEditMode, setIsEditMode] = useState(false); // Toggle to manage edit mode
  const [isApproveMode, setIsApproveMode] = useState(false); // Toggle to manage edit mode
  const [isSendApproveMode, setIsSendApproveMode] = useState(false); // Toggle to manage edit mode
  const [IsRejecMode, setIsRejecMode] = useState(false); // Toggle to manage edit mode
  const [openRequestId, setOpenRequestId] = useState(null); // Track dropdown per row
  const [selectedRow, setSelectedRow] = useState(null); // Track selected row for color change
  const [isUnHoldMode, setIsUnHoldMode] = useState(false); // Toggle to manage edit mode
  const dropdownRef = useRef(null); // Ref for the dropdown menu
  const [isConfrimModalVisible, setIsConfirmModalVisible] = useState(false);
  const [errors, setErrors] = useState({});
   const [isHoldMode, setIsHoldMode] = useState(false); // Toggle to manage edit mode
  const [isApproving, setisApproving] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isPlanDate, setPlanDate] = useState(false); // Toggle to manage edit mode
  const { instance } = useMsal(); 
  const [activeTab, setActiveTab] = useState("details");
const [currentDocument, setCurrentDocument] = useState(selectedRequest?.documents || null);
    const [selectedRecruiter, setselectedRecruiter] = useState(null);
 const [isJdViewerOpen, setIsJdViewerOpen] = useState(false);
  // Handle outside click for closing the dropdown
  useEffect(() => {
  
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenRequestId(null); // Close dropdown when clicking outside
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  useEffect(() => {
    if (isApproveMode) {
      setSelectedRequest((prev) => ({
        ...prev,
        status: "Approved",
      }));
    }
  }, [isApproveMode]);
  
  const toggleMenu = (requestId) => {
    // Toggle the dropdown for the clicked request row
    setOpenRequestId(openRequestId === requestId ? null : requestId);
    setSelectedRow(openRequestId === requestId ? null : requestId); // Change row color
  };

  // Handle view modal
  const handleView = (requestId) => {
    const request = hiringRequests.find(req => req.request_id === requestId);
    
    setSelectedRequest(request);
    setIsModalVisible(true);
    setIsEditMode(false); // Ensure view mode is set
    setIsApproveMode(false);
    setIsSendApproveMode(false);
    setIsRejecMode(false);
    setIsUnHoldMode(false);
    setIsHoldMode(false);
    setPlanDate(false);
  };
  const userRole = getToken();
  
  // Handle edit modal
  const handleEdit = (requestId) => {
    const request = hiringRequests.find(req => req.request_id === requestId);
    setSelectedRequest(request);
    setIsModalVisible(true);
    setIsEditMode(true); // Enable edit mode
    setIsApproveMode(false);
    setIsSendApproveMode(false);
    setIsRejecMode(false);
    setIsUnHoldMode(false);
    setIsHoldMode(false);
    setPlanDate(false);
  };
  const handlePlanDate= (requestId) => {
    const request = hiringRequests.find(req => req.request_id === requestId);
    setSelectedRequest(request);
    setIsModalVisible(true);
    setIsEditMode(false); // Enable edit mode
    setIsApproveMode(false);
    setIsSendApproveMode(false);
    setIsRejecMode(false);
    setIsUnHoldMode(false);
    setIsHoldMode(false);
    setPlanDate(true);
  };
  const handleApprove = (requestId) => {
    const request = hiringRequests.find(req => req.request_id === requestId);
    setSelectedRequest(request);
    setIsModalVisible(true);
    setIsApproveMode(true); // Enable edit mode
    setIsEditMode(false); 
    setIsSendApproveMode(false);
    setIsRejecMode(false);
    setIsUnHoldMode(false);
    setIsHoldMode(false);
    setPlanDate(false);
  };
  const handleSendApprove = (requestId) => {
    const request = hiringRequests.find(req => req.request_id === requestId);
    setSelectedRequest(request);
    setIsModalVisible(true);
    setIsSendApproveMode(true); // Enable edit mode
    setIsEditMode(false); 
    setIsApproveMode(false); // Enable edit mode
    setIsRejecMode(false);
    setIsHoldMode(false);
    setIsUnHoldMode(false);
    setPlanDate(false);
  };
  const handleReject = (requestId) => {
    const request = hiringRequests.find(req => req.request_id === requestId);
    setSelectedRequest(request);
    setIsModalVisible(true);
    setIsSendApproveMode(false); // Enable edit mode
    setIsEditMode(false); 
    setIsApproveMode(false); // Enable edit mode
    setIsRejecMode(true);
    setIsUnHoldMode(false);
    setIsHoldMode(false);
    setPlanDate(false);
  };
  const handleUnHold = (requestId) => {
    const request = hiringRequests.find(req => req.request_id === requestId);
    setSelectedRequest(request);
    setIsModalVisible(true);
    setIsSendApproveMode(false); // Enable edit mode
    setIsEditMode(false); 
    setIsApproveMode(false); // Enable edit mode
    setIsRejecMode(false);
    setIsUnHoldMode(true);
    setIsHoldMode(false);
    setPlanDate(false);
  };
    const handleHold = (requestId) => {
    const request = hiringRequests.find(req => req.request_id === requestId);
    setSelectedRequest(request);
    setIsModalVisible(true);
    setIsSendApproveMode(false); // Enable edit mode
    setIsEditMode(false); 
    setIsApproveMode(false); // Enable edit mode
    setIsRejecMode(false);
    setIsUnHoldMode(false);
    setIsHoldMode(true);
    setPlanDate(false);
  };
  const handleRecruiterChange = (selectedOption) => {
    setselectedRecruiter(selectedOption ? selectedOption.value : null);
    
   
  };
  const handleConvertClick = (requestId) => {
    const request = hiringRequests.find(req => req.request_id === requestId);
    setSelectedRequest(request);
    setIsConfirmModalVisible(true);
  };
 const handleRequestCreated = () => {
  // Refresh the hiring requests list
  loadHiringRequests();
};

  // Close modal (reset selected request)
  const closeModal = () => {
    setIsModalVisible(false);
    setSelectedRequest(null);
  };
  const handleEditSave  = async () => {
    
    let validationErrors = {};
    validationErrors = validateselectedForm();
    
    const userName = getUserFromToken();
    selectedRequest.updated_by=userName;
    // If there are validation errors, update the state with the errors
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      setIsSubmitting(false);
      return; // Stop further processing if there are validation errors
    }
    setErrors({});
    try {
      setIsSubmitting(true);
      // Use the API service to save the new hiring request to the database
      const savedRequest = await UpdateHiringRequest(selectedRequest);
  
      if (Number(savedRequest.status) === 400) {
        toast.error("Hiring request cannot be created as Requested Count exceeds forecasted hires");
      } else if (savedRequest.status === 500) {
        toast.error("Failed to save the hiring request.");
      } else {
        toast.success("Hiring request Updated successfully!");
  
        setHiringRequests(prevRequests =>
          prevRequests.map(request =>
            request.request_id === selectedRequest.request_id
              ? { ...request, ...selectedRequest }  // Update existing request
              : request  // Keep other requests unchanged
          )
        );
           setIsModalVisible(false); // Close the popup after 5 seconds (or a shorter delay if desired)
          setIsSubmitting(false)
        // Close the form/popup after a short delay to allow the toast to show
 
      }  
    } catch (error) {
      console.error('Error saving hiring request:', error);
      toast.error("An error occurred while saving the hiring request." )
    }

 
  };
  // Handle save
  const handleSaveSendApprove = async () => {
    let validationErrors = {};
    // ⏳ Disable button immediately on submit
    
    const validateStatuForm = () => {
      const newErrors = {};
      if (!selectedRequest.notes || selectedRequest.notes.trim() === '') {
        newErrors.notes = 'Please enter notes.';
      }
      setIsSubmitting(false);
      return newErrors;
    };
  
    try {
      // Perform validation
      validationErrors = validateStatuForm();
  
      // If there are validation errors, show toast and stop further execution
    if (Object.keys(validationErrors).length > 0) {
    setErrors(validationErrors);

    // Show the first validation error in toast
    const firstError = Object.values(validationErrors)[0];
    toast.error(firstError);

    setIsSubmitting(false);  // Re-enable button if validation fails
    return;
  }
  
      // Start the approval process
      setIsSubmitting(true);
  
      const userName = getUserFromToken();
  
      const bodyReq = {
        Request_id: selectedRequest.request_id,
        old_status: selectedRequest.status,
        new_status: 'Submitted',  // Hardcoded new status, assuming you're submitting the request
        logDescription: selectedRequest.notes.trim(),
        change_by: userName,
      };
  
      // Simulate API call to update request status
      const savedRequest = await SaveHiringRequestStatus(bodyReq);
  
      if (savedRequest) {
        // Success: show success toast
        toast.success(`Request status updated to "Submitted" successfully!` );
  

        // Update the request list with the updated request
        setHiringRequests(prevRequests =>
          prevRequests.map(request =>
            request.request_id === selectedRequest.request_id
              ? { ...request, status: 'Submitted', notes: selectedRequest.notes.trim() }  // Ensure notes and status are updated
              : request
          )
        );
    setIsModalVisible(false);  // Close the modal after 5 seconds
          setSelectedRequest(null); 
          setIsSubmitting(false); // Re-enable button for next action

            if (userRole.IsDepartmentRestricted === "True") {

         try {
                
        
                
          const roles = selectedRequest.request_type === "Forecast"
  ? DemandPlanning.find(manager => Number(manager.demand_id) === Number(selectedRequest.demand_id))?.role
  : selectedRequest.role_text;

      const departmentName =
        departments.find(
          (dept) =>
            Number(dept.department_id) ===
            Number(selectedRequest.department_id)
        )?.department_name || "";

               
const isExcOrOut = selectedRequest.request_type === "Exceptional" || selectedRequest.request_type === "Outsourced";
await SendApprovalWorkflowEmailAsync({
  recipientRole: isExcOrOut ? "Finance Manager" : "HR Director",
  companyCode: selectedRequest.companyCode || getToken()?.companyCode || '',
  hiringManagerUserId: Number(selectedRequest.hiring_manager) || null,
  requestId: savedRequest.data.hiringRequestId, referenceNumber: '',
  action: "Submitted", actorName: getUserFromToken(), actorRole: "Business Owner",
  nextStep: isExcOrOut ? "Pending Finance Approval" : "Pending HR Director Approval",
  notes: '', department: departmentName, position: selectedRequest.position || '', requestType: selectedRequest.request_type || '',
});



              } catch (emailError) {
                console.error("Failed to send email to business owner:", emailError);
                toast.warn("Candidates approved but email to business owner failed.");
              }
            }
        // ✅ Close the modal only after successful submission
        
      } else {
        // Failure: show error toast
        toast.error(`Failed to update request status to "Submitted".` );
  
        
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("An error occurred while updating the status." );
  
      // Re-enable button in case of error
      setIsSubmitting(false);
    }
  };
  const handleRejectSave = async () => {
    let validationErrors = {};
    // ⏳ Disable button immediately on submit
    
    const validateStatuForm = () => {
      const newErrors = {};
      if (!selectedRequest.notes || selectedRequest.notes.trim() === '') {
        newErrors.notes = 'Please enter notes.';
      }
      setIsSubmitting(false);
      return newErrors;
    };
  
    try {
      // Perform validation
      validationErrors = validateStatuForm();
  
      // If there are validation errors, show toast and stop further execution
   if (Object.keys(validationErrors).length > 0) {
    setErrors(validationErrors);

    // Show the first validation error in toast
    const firstError = Object.values(validationErrors)[0];
    toast.error(firstError);

    setIsSubmitting(false);  // Re-enable button if validation fails
    return;
  }
      // Start the approval process
      setIsSubmitting(true);
  
      const userName = getUserFromToken();
  
      const bodyReq = {
        Request_id: selectedRequest.request_id,
        old_status: selectedRequest.status,
        new_status: 'Rejected',  // Hardcoded new status, assuming you're submitting the request
        logDescription: selectedRequest.notes.trim(),
        change_by: userName,
        demand_id :selectedRequest.demand_id
      };
  
      // Simulate API call to update request status
      const savedRequest = await SaveHiringRequestStatus(bodyReq);
  
      if (savedRequest) {
        // Success: show success toast
        toast.success(`Request status updated to "Rejected" successfully!`);
selectedRequest.status="Rejected";
       
        // Update the request list with the updated request
        setHiringRequests(prevRequests =>
          prevRequests.map(request =>
            request.request_id === selectedRequest.request_id
              ? { ...request, status: 'Rejected', notes: selectedRequest.notes.trim() }  // Ensure notes and status are updated
              : request
          )
        );
  
        // ✅ Close the modal only after successful submission
            setIsModalVisible(false);  // Close the modal after 5 seconds
          setSelectedRequest(null); 
          setIsSubmitting(false); // Re-enable button for next action
            await notifyHiringManager(selectedRequest);
  
      } else {
        // Failure: show error toast
        toast.error(`Failed to update request status to "Submitted".`);
  
        
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("An error occurred while updating the status." );
  
      // Re-enable button in case of error
      setIsSubmitting(false);
    }
  };
  
  const notifyHiringManager = async (selectedRequest) => {
   
  const hiringManager = hiringManagers.find(
    (m) => m.user_id === selectedRequest.hiring_manager
  );

  if (!hiringManager?.email) return;




 const emailBody = {

  managerEmail: hiringManager.email,
  requestId: selectedRequest.request_id,
  status: selectedRequest.status,
  notes: selectedRequest.notes.trim()
};

await SendApprovalEmailToHiringManagerAsync(emailBody);

};


  const handleSaveApprove = async () => {
    let validationErrors = {};
    // ⏳ Disable button immediately on submit
 
    const validateStatuForm = () => {
      const newErrors = {};
      if (!selectedRequest.notes ) {
        newErrors.notes = 'Please enter notes.';
      }
      setisApproving(false);
      return newErrors;
    };
  
    try {
      validationErrors = validateStatuForm();
  
   if (Object.keys(validationErrors).length > 0) {
    setErrors(validationErrors);

    // Show the first validation error in toast
    const firstError = Object.values(validationErrors)[0];
    toast.error(firstError);

    setIsSubmitting(false);  // Re-enable button if validation fails
    return;
  }
      setisApproving(true);
      const userName = getUserFromToken();
  
      const bodyReq = {
        Request_id: selectedRequest.request_id,
        old_status: 'Submitted',
        new_status: selectedRequest.status,
        logDescription: selectedRequest.notes.trim(),
        change_by: userName,
      };
 
      const savedRequest = await SaveHiringRequestStatus(bodyReq);
  
      if (savedRequest) {
        toast.success(`Request status updated to "${selectedRequest.status}" successfully!`);
        selectedRequest.status="Approved"
       

  setHiringRequests(prevRequests =>
          prevRequests.map(request =>
            request.request_id === selectedRequest.request_id
              ? { ...request, ...selectedRequest }
              : request
          )
        );
      } else {
        toast.error(`Failed to update request status to "${selectedRequest.status}".`);
        
      }
 if (Object.keys(validationErrors).length === 0) {
       setIsModalVisible(false);
          setSelectedRequest(null);
          setisApproving(false);
           await notifyHiringManager(selectedRequest);
      }
            
    } catch (error) {
      console.error("Error:", error);
      toast.error("An error occurred while updating the status." );
    } finally {
      // ✅ Re-enable the button no matter what
  
     

    }
  };
  
    const handleSaveUnHold = async () => {
    let validationErrors = {}; // Declare validationErrors outside of try block
  
    try {
      // Validate the form
      validationErrors = validateStatuForm();
  
    
      // If there are validation errors, set them and stop further processing
        if (Object.keys(validationErrors).length > 0) {
    setErrors(validationErrors);

    // Show the first validation error in toast
    const firstError = Object.values(validationErrors)[0];
    toast.error(firstError);

    setIsSubmitting(false);  // Re-enable button if validation fails
    return;
  }
      setIsSubmitting(true);
      const userName = getUserFromToken();
  
      const bodyReq = {
        Request_id: selectedRequest.request_id,
        old_status: 'On Hold',
        new_status: "Submitted",
        logDescription: selectedRequest.notes,
        change_by: userName,
      };
  
      // Simulate API call or any async action (Save the hiring request status)
      const savedRequest = await SaveHiringRequestStatus(bodyReq);
  
      if (savedRequest) {
        // Success: show success toast
        toast.success("Request status updated successfully!");
        selectedRequest.status="Submitted"
  

        // Update the existing hiring request in the list based on request_id
        setHiringRequests(prevRequests =>
          prevRequests.map(request =>
            request.request_id === selectedRequest.request_id
              ? { ...request, ...selectedRequest }  // Update existing request
              : request  // Keep other requests unchanged
          )
          
        );
      
      } else {
        // Failure: show error toast
        toast.error("Failed to update request status.");
      }
       if (Object.keys(validationErrors).length === 0) {
          setIsModalVisible(false);  // Close the modal after 5 seconds
          setSelectedRequest(null);
            setIsSubmitting(false); 
                     await notifyHiringManager(selectedRequest);
      }
    } catch (error) {
      // Catch any unexpected errors
      console.error("Error:", error);
      toast.error("An error occurred while updating the status." );
    } finally {
      // Close the modal and clear the selected request only if no validation errors
 
    }
  };
  
  const handleSaveHold = async () => {
    let validationErrors = {}; // Declare validationErrors outside of try block
  
    try {
      // Validate the form
      validationErrors = validateStatuForm();
  
      // If there are validation errors, set them and stop further processing
   if (Object.keys(validationErrors).length > 0) {
    setErrors(validationErrors);

    // Show the first validation error in toast
    const firstError = Object.values(validationErrors)[0];
    toast.error(firstError);

    setIsSubmitting(false);  // Re-enable button if validation fails
    return;
  }
   setIsSubmitting(true); 
      const userName = getUserFromToken();
  
      const bodyReq = {
        Request_id: selectedRequest.request_id,
        old_status: selectedRequest.status,
        new_status: 'On Hold', 
        logDescription: selectedRequest.notes,
        change_by: userName,
      };
  
      // Simulate API call or any async action (Save the hiring request status)
      const savedRequest = await SaveHiringRequestStatus(bodyReq);
  
      if (savedRequest) {
        // Success: show success toast
        toast.success("Request status updated successfully!");
         selectedRequest.status="On Hold"
       
        // Update the existing hiring request in the list based on request_id
        setHiringRequests(prevRequests =>
          prevRequests.map(request =>
            request.request_id === selectedRequest.request_id
              ? { ...request, ...selectedRequest }  // Update existing request
              : request  // Keep other requests unchanged
          )
        );
         if (Object.keys(validationErrors).length === 0) {
          setIsModalVisible(false);  // Close the modal after 5 seconds
          setSelectedRequest(null);
            setIsSubmitting(false); 
              await notifyHiringManager(selectedRequest);
      }
      } else {
        // Failure: show error toast
        toast.error("Failed to update request status.");
       
      }
  
    } catch (error) {
      // Catch any unexpected errors
      console.error("Error:", error);
      toast.error("An error occurred while updating the status." );
    } finally {
      // Close the modal and clear the selected request only if no validation errors
    
    }
  };
  
  const validateStatuForm = () => {
    const newErrors = {};
    
    if (!selectedRequest.notes) newErrors.notes = 'Notes is required.';
    return newErrors;
  }
  const validateselectedForm = () => {
    const newErrors = {};
    
    if (!selectedRequest.department_id) newErrors.department_id = 'Department is required.';
       if (!selectedRequest.request_type) {
  newErrors.request_type = "Request type is required.";
}

   if (selectedRequest.request_type === "Forecast") {
  if (!selectedRequest.demand_id) {
    newErrors.demand_id = "Role is required.";
  }
} else if (selectedRequest.request_type === "Exceptional") {
  if (!selectedRequest.role_text || selectedRequest.role_text.trim() === "") {
    newErrors.role_text = "Role is required.";
  }
}
    if (!selectedRequest.hiring_manager) newErrors.hiring_manager = 'Hiring Manager is required.';
    if (!selectedRequest.position) newErrors.position = 'position is required.';
    
    //if (!selectedRequest.job_description_file) newErrors.job_description_file = 'Job Description is required.';
    if (!selectedRequest.reason_for_hire) newErrors.reason_for_hire = 'Reason for Hire is required.';
    if (!selectedRequest.planned_start_date) newErrors.planned_start_date = 'Planned Start Date is required.';
    if (!selectedRequest.status) newErrors.status = 'status is required.';
    if (!selectedRequest.priority) newErrors.priority = 'priority is required.';
    if (!selectedRequest.position_type) newErrors.position_type = 'position Type is required.';
    

    return newErrors;
  };
const handleConfirm = async () => {
  try {
    if (!selectedRecruiter) {
      setErrors({ recruiter: "Please select a recruiter (HR Incharge)." });
      toast.error("Recruiter selection is required." );
      return;
    }

    const userName = getUserFromToken();
    const bodyReq = {
      Request_id: selectedRequest.request_id,
      old_status: selectedRequest.status,
      new_status: selectedRequest.status,
      logDescription: "Convert to sourcing",
      change_by: userName,
      recruiter_id: selectedRecruiter,
    };

    setIsSubmitting(true);
    const savedRequest = await UpdateIsConevrtToSource(bodyReq);

    if (savedRequest) {
      selectedRequest.isConevrtToSource = true;

      setHiringRequests((prevRequests) =>
        prevRequests.map((request) =>
          request.request_id === selectedRequest.request_id
            ? { ...request, ...selectedRequest }
            : request
        )
      );
      
 
 


      toast.success("Successfully converted to Sourcing!");
    } else {
      toast.error("Failed to update request status.");
    }
  } catch (error) {
    console.error("Error:", error);
    toast.error("An error occurred while updating the status.");
  } finally {
        setIsConfirmModalVisible(false);
      setSelectedRequest(null);
      setIsSubmitting(false);

            // ✅ Send email to the recruiter
      const recruiter = hiringManagers.find(
        (m) => m.user_id === selectedRecruiter
      );
           
          const roles = selectedRequest.request_type === "Forecast"
  ? DemandPlanning.find(manager => Number(manager.demand_id) === Number(selectedRequest.demand_id))?.role
  : selectedRequest.role_text;

      const departmentName =
        departments.find(
          (dept) =>
            Number(dept.department_id) ===
            Number(selectedRequest.department_id)
        )?.department_name || "";

      if (recruiter  ) {
const newRequest = {
  RecipientEmail: recruiter.email,
  RecipientName: `${recruiter.first_name} ${recruiter.last_name}`,
  Role: roles + '(' + selectedRequest.position + ')',
  Department: departmentName,
  RequestId: selectedRequest.request_id
};

await SendSourcingAssignmentEmailAsync(newRequest);

        
     
      }
  }
};


  // Function to cancel the conversion
  const handleCancel = () => {
   

    // Reset modal visibility on cancel
    setIsConfirmModalVisible(false);
    setSelectedRequest(null);
  };
  // Close modal if clicking outside
  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      closeModal();
    }
  }; 
   const [jobDescriptionFile, setJobDescriptionFile] = useState(null);
   const [showDocPreview, setShowDocPreview] = useState(false);

  const [step, setStep] = useState(1);
const [currentPage, setCurrentPage] = useState(1);
//const itemsPerPage = 10;
const [itemsPerPage, setItemsPerPage] = useState(10);
  const selectStyles = {
  control: (base) => ({
    ...base,
    borderRadius: 8,
    borderColor: '#f5f3ef',
    padding: '0 8px',
    boxShadow: 'none',
    height: '48px',
  }),
  dropdownIndicator: (base) => ({ ...base, padding: 4 }),
  indicatorSeparator: () => ({ display: 'none' }),
};
  useEffect(() => {
   
    const userRole = getToken();
 

    const userName = getUserFromToken();
    newRequest.created_by=userName;
    const loadDepartments = async () => {
      try {
        
        const deptData = await fetchActiveDepartments();
        if (userRole.IsDepartmentRestricted === "True") {
            
          const departmentId = getDepartmentIdFromToken();
         
          setDepartments(deptData.filter(dept => String(dept.department_id) === String(departmentId)));
         
        } else {
            
          setDepartments(deptData);
        }
      } catch (err) {
        console.error("Failed to load departments:", err);
      }
    };

const loadHiringManagers = async () => {
  try {
    const managers = await fetchHiringManagers();
    if (userRole.IsDepartmentRestricted === "True") {
      const filtered = managers.filter(
        (dept) => String(dept.username) === String(userName)
      );
      
      setHiringManagers(filtered);
      
      if (filtered.length > 0) {
        // Automatically set selectedHiringManager to the only available manager
        setSelectedHiringManager(filtered[0].user_id);
      }
    } else {
      setHiringManagers(managers);
    }
  } catch (err) {
    console.error("Failed to load hiring managers:", err);
  }
};


    const loadDemandPlan = async () => {
      try {
      
        const dplan = await GetDemandPlanning(selectedYear);
        setDemandPlanning(dplan);
        
      } catch (err) {
        console.error("Failed to load demand plan:", err);
      }
    };



    loadDepartments();
    loadHiringManagers();
    loadHiringRequests();
    loadDemandPlan();
  }, []);

const loadHiringRequests = async () => {
  try {
    setLoading(true);
        const userRole = getToken();
    const requests = await fetchHiringRequests();

    const departmentId = getDepartmentIdFromToken();

    if (userRole.IsDepartmentRestricted === "True") {
      // First filter by department
      let filtered = requests.filter(
        (req) => String(req.department_id) === String(departmentId)
      );

      // Then filter by selected hiring manager (if any)
      if (selectedHiringManager) {
        filtered = filtered.filter(
          (req) => String(req.hiring_manager) === String(selectedHiringManager)
        );
      }

      setHiringRequests(filtered);
    } else {
      const filteredRequests = requests.filter((req) => {
        const isDraftExcluded = req.isDepartmentRestricted
          ? req.status !== "Draft"
          : true;
        return isDraftExcluded;
      });

      setHiringRequests(filteredRequests);
    }
  } catch (err) {
    console.error(err);
    setError("Failed to load hiring requests");
  } finally {
    setLoading(false);
  }
};

  const handleDepartmentChange = async (e) => {
    const selectedDeptId = e.target.value;
  
    setNewRequest((prev) => ({
      ...prev,
      department_id: selectedDeptId,
    }));
  
    if (selectedDeptId) {
      try {
        
        const roles = await fetchRolesForDepartment(newRequest.years,selectedDeptId );
        setRolesForDepartment(roles);
      } catch (error) {
        console.error("Error fetching roles:", error);
      }
    }
  };
 const handleJobDescriptionFileUpload = (e) => {
  const file = e.target.files[0];
  const validTypes = [
    "application/pdf",
    "application/msword", // .doc
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document" // .docx
  ];

  if (!file) {
    toast.error("No file selected.");
    return;
  }

  if (!validTypes.includes(file.type)) {
    toast.error("Invalid file type. Only PDF, DOC, or DOCX files are allowed.");
    e.target.value = null;
    return;
  }

  if (file.size > 5 * 1024 * 1024) {
    toast.error("File size exceeds 5MB. Please upload a smaller file.");
    e.target.value = null;
    return;
  }

  const userName = getUserFromToken();
  const reader = new FileReader();

  reader.onloadend = () => {
    const base64String = reader.result.split(",")[1];

    setNewRequest((prev) => ({
      ...prev,
      job_description_file: reader.result, // Full Base64 with prefix
      Documents: {
        ...prev.Documents,
        FileName: file.name,
        FileBase64: base64String, // Just the Base64 content
        Size: file.size,
        MimeType: file.type,
        reference_id: "0",
        process_type: "JobDescription",
        uploaded_by: userName,
        uploaded_at: new Date().toISOString(),
        IsActive: true,
      },
    }));

    // Clear any previous error
    if (setError) {
      setError("");
    }
  };

  reader.readAsDataURL(file);
};


  const handleYearChange = async (e) => {
    const selectedYear =  e.target.value;
  
    setNewRequest((prev) => ({
      ...prev,
      years: selectedYear,
    }));
  
    if (newRequest.department_id) {
      try {
        const roles = await fetchRolesForDepartment(selectedYear,newRequest.department_id );
        setRolesForDepartment(roles);
      } catch (error) {
        console.error("Error fetching roles:", error);
      }
    }
  };
  const yearOptions = [
    new Date().getFullYear() - 1,
    new Date().getFullYear(),
    new Date().getFullYear() + 1,
  ].map((year) => ({ value: year, label: year.toString() }));

  const validateForm = () => {
    const newErrors = {};
    
    if (!newRequest.department_id) newErrors.department_id = 'Department is required.';
    if (!newRequest.years) newErrors.years = 'Years is required.';
    if (!newRequest.request_type) {
  newErrors.request_type = "Request type is required.";
}

   if (newRequest.request_type === "Forecast") {
  if (!newRequest.demand_id) {
    newErrors.demand_id = "Role is required.";
  }
} else if (newRequest.request_type === "Exceptional") {
 
  if (!newRequest.role_text || newRequest.role_text.trim() === "") {
    newErrors.role_text = "Role is required.";
  }
}

   

    if (!newRequest.hiring_manager) newErrors.hiring_manager = 'Hiring Manager is required.';
    if (!newRequest.position) newErrors.position = 'position is required.';
    
    if (!newRequest.job_description_file) newErrors.job_description_file = 'Job Description is required.';
    if (!newRequest.reason_for_hire) newErrors.reason_for_hire = 'Reason for Hire is required.';
    if (!newRequest.planned_start_date) newErrors.planned_start_date = 'Planned Start Date is required.';
    if (!newRequest.status) newErrors.status = 'status is required.';
    if (!newRequest.priority) newErrors.priority = 'priority is required.';
    if (!newRequest.position_type) newErrors.position_type = 'Position Type is required.';
 if (!newRequest.hiring_Type) newErrors.hiring_Type = 'Hiring Type is required.';
    
 
 if (newRequest.request_type === "Forecast") {
  if (!newRequest.demand_id) {
    newErrors.demand_id = "Role is required.";
  }
} else if (newRequest.request_type === "Exceptional") {
 
  if (!newRequest.role_text || newRequest.role_text.trim() === "") {
    newErrors.role_text = "Role is required.";
  }
}

    return newErrors;
  };
  const handleFormSubmit = async () => {

      if (newRequest.request_type === "Forecast") {
        newRequest.position =newRequest.positionForcast;
      }
      else{
         newRequest.position =newRequest.positionExeptional;
      }
    let validationErrors = {};
  
  newRequest.planned_start_date =datePlus120Str;
    // ⏳ Disable button immediately on submit
    const validateFormFields = () => {
      const newErrors = {};
  
      if (!newRequest.department_id) newErrors.department_id = 'Department is required.';
      if (!newRequest.years) newErrors.department_id = 'years is required.';
     // if (!newRequest.job_description_file) newErrors.job_description_file = 'Job description is required.';
      if (!newRequest.hiring_manager) newErrors.hiring_manager = 'Hiring manager is required.';
      if (!newRequest.position) newErrors.position = 'Position is required.';
      
      if (!newRequest.reason_for_hire) newErrors.reason_for_hire = 'Reason for hire is required.';
      if (!newRequest.planned_start_date) newErrors.planned_start_date = 'Planned start date is required.';
      if (!newRequest.status) newErrors.status = 'Status is required.';
      if (!newRequest.priority) newErrors.priority = 'Priority is required.';
      if (!newRequest.position_type) newErrors.position_type = 'Position type is required.';

            if (!newRequest.hiring_Type) newErrors.hiring_Type = 'Hiring type is required.';
      
    
   if (newRequest.request_type === "Forecast") {
    newRequest.IsFinanceManagerApproveRequired=false
  if (!newRequest.demand_id) {
    newErrors.demand_id = "Role is required.";
  }
} else if (newRequest.request_type === "Exceptional") {
     newRequest.IsFinanceManagerApproveRequired=true
  if (!newRequest.role_text || newRequest.role_text.trim() === "") {
    newErrors.role_text = "Role is required.";
  }
}
      return newErrors;
    };
  
    try {
      // Add selected hiring manager and department restriction flag
      newRequest.hiring_manager = selectedHiringManager;
      const userRole = getToken();
      newRequest.IsDepartmentRestricted = userRole.IsDepartmentRestricted === "True";
   const CompanyCode =
        departments.find(
          (dept) =>
            Number(dept.department_id) ===
            Number(newRequest.department_id)
        )?.company || "";
      // Validate
      validationErrors = validateFormFields();
  
  if (Object.keys(validationErrors).length > 0) {
  Object.entries(validationErrors).forEach(([field, message]) => {
    toast.error(message );
  });
  return;
}

  
      // If validation passed
      setErrors({});
      setIsSubmitting(true);
      newRequest.companyCode=CompanyCode
  //console.log(JSON.stringify(newRequest));
      // Save to database
      const savedRequest = await saveHiringRequest(newRequest);
  
      if (Number(savedRequest.status) === 400) {
        toast.error("Hiring request cannot be created as Requested Count exceeds forecasted hires");
        setIsSubmitting(false);
      } else if (savedRequest.status === 500) {
        toast.error("Failed to save the hiring request.");
        setIsSubmitting(false);
      } else {
        toast.success("Hiring request saved successfully!");

            
        setHiringRequests((prev) => [
  {
    
    ...newRequest,
    Documents: newRequest.Documents, // explicitly attach the uploaded document
  },
  ...prev,
]);

  
   
  
       setIsFormVisible(false);
          setIsSubmitting(false);
             if (userRole.IsDepartmentRestricted === "True" && newRequest.status==="Submitted") {

         try {
      
          const roles = newRequest.request_type === "Forecast"
  ? DemandPlanning.find(manager => Number(manager.demand_id) === Number(newRequest.demand_id))?.role
  : newRequest.role_text;

      const departmentName =
        departments.find(
          (dept) =>
            Number(dept.department_id) ===
            Number(newRequest.department_id)
        )?.department_name || "";

 const isExcOrOut2 = newRequest.request_type === "Exceptional" || newRequest.request_type === "Outsourced";
await SendApprovalWorkflowEmailAsync({
  recipientRole: isExcOrOut2 ? "Finance Manager" : "HR Director",
  companyCode: newRequest.companyCode || getToken()?.companyCode || '',
  hiringManagerUserId: Number(newRequest.hiring_manager || selectedHiringManager) || null,
  requestId: savedRequest.data.hiringRequestId, referenceNumber: '',
  action: "Submitted", actorName: getUserFromToken(), actorRole: "Business Owner",
  nextStep: isExcOrOut2 ? "Pending Finance Approval" : "Pending HR Director Approval",
  notes: '', department: departmentName, position: newRequest.position || '', requestType: newRequest.request_type || '',
});
              } catch (emailError) {
                console.error("Failed to send email to business owner:", emailError);
                toast.warn("Candidates approved but email to business owner failed.");
              }
            }

                 setNewRequest({
          department_id: "",
          job_description: "",
          job_description_file: "",
          position:"",
          hiring_manager: "",
          reason_for_hire: "",
          planned_start_date: "",
          status: "",
          priority: "",
          position_type: "",
          hiring_Type:"",
          preferred_requirment:"",
          demand_id:"0",
          role_text:"",
          companyCode:"",
          request_type:"",
          years:new Date().getFullYear(),
          IsDepartmentRestricted: "",
           Documents: {
        FileName: "",
        FileBase64: "",
        Size: 0,
        MimeType: "",
        reference_id: "0",
        process_type: "",
        uploaded_by: "",
        uploaded_at: "", // or null if you're using Date object
        IsActive: true
      }
        });
      }
    } catch (error) {
      console.error('Error saving hiring request:', error);
      toast.error("An error occurred while saving the hiring request. ");
    } finally {
      await loadHiringRequests();
      // ✅ Re-enable the button regardless of outcome
      
    }
  };
  
  
    const nextStep = () => setStep((s) => s + 1);
  const prevStep = () => setStep((s) => s - 1);
  

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    
    setNewRequest((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleHiringManagerChange = (selectedOption) => {
    
    setSelectedHiringManager(selectedOption ? selectedOption.value : null);
    //console.log(hiringManagers);
   
  };
const handleCloseForm = () => {
  setIsFormVisible(false);
 
};

 


  const handleStatusChange = (status, e) => {
    e.preventDefault(); // Prevent default behavior of the event
    newRequest.hiring_manager = selectedHiringManager;
    newRequest.status = status;
     
    // Update the status in the state (assuming newRequest is in the state)
    
  
    // Now trigger the form submission
    handleFormSubmit();
  };
    // Filter hiring requests based on department and search query
    // const filteredRequests = hiringRequests.filter((request) => {
     
    //   if(selectedDepartment !='all'){
    //   const isDepartmentMatch =
    //     !selectedDepartment || request.department_id === selectedDepartment;
    //   const isSearchMatch =
    //     !searchQuery ||
    //     request.reason_for_hire.toLowerCase().includes(searchQuery.toLowerCase()) ||
    //     request.job_description.toLowerCase().includes(searchQuery.toLowerCase());
    //   return isDepartmentMatch && isSearchMatch;
    //   }
    //   else{
    //       const isSearchMatch =
    //       !searchQuery ||
    //       request.reason_for_hire.toLowerCase().includes(searchQuery.toLowerCase()) ||
    //       request.job_description.toLowerCase().includes(searchQuery.toLowerCase());
    //       return   isSearchMatch;
    //   }
    // });
 


   const filteredRequests = hiringRequests.filter((request) => {
  const isDepartmentMatch =
    selectedDepartment === 'all' || request.department_id === selectedDepartment;

  const isStatusMatch =
    selectedStatus === 'all' || request.status === selectedStatus;

  const isYearsMatch =
    String(request.years) === String(selectedYear);

  const isSourcingMatch =
    selectedSourcing === 'all' || request.isConevrtToSource === (selectedSourcing === 'YES');

  const isSearchMatch =
    !searchQuery ||
    request.reason_for_hire.toLowerCase().includes(searchQuery.toLowerCase()) ||
    request.position.toLowerCase().includes(searchQuery.toLowerCase())  
      request.role_text.toLowerCase().includes(searchQuery.toLowerCase())  

  return (
    isDepartmentMatch &&
    isStatusMatch &&
    isYearsMatch &&
    isSourcingMatch &&
    isSearchMatch
  );
});
const indexOfLastItem = currentPage * itemsPerPage;
const indexOfFirstItem = indexOfLastItem - itemsPerPage;
 

const totalPages = Math.ceil(filteredRequests.length / itemsPerPage);

const paginatedRequests = filteredRequests.slice(
  (currentPage - 1) * itemsPerPage,
  currentPage * itemsPerPage
);
const startIndex = (currentPage - 1) * itemsPerPage;
const endIndex = Math.min(startIndex + itemsPerPage, paginatedRequests.length);
    const resetFilters = () => {
      setSearchQuery('');
      setSelectedDepartment('all');
      setSelectedStatus('all');
      setSelectedSourcing('all');
      setSelectedYear(new Date().getFullYear()); // Reset year
    };
    
    
const today = new Date();
const datePlus120 = new Date(today.setDate(today.getDate() + 120));
const datePlus120Str = datePlus120.toISOString().split("T")[0];


 if (loading) return <LoadingSpinner label="Loading Hiring Requests" />;

if (error) {
  return (
    <div style={styles.errorContainer} className="bg-white rounded-2xl shadow-sm">
      {/* Error Icon */}
      <div className="relative mb-6">
        <div className="w-20 h-20 rounded-full flex items-center justify-center"
             style={{ backgroundColor: 'rgba(239, 68, 68, 0.1)' }}>
          <svg className="w-10 h-10" style={{ color: 'rgb(239, 68, 68)' }} 
               fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" 
                  d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        
        {/* Animated rings */}
        <div className="absolute inset-0 rounded-full animate-ping" 
             style={{ backgroundColor: 'rgba(239, 68, 68, 0.2)' }}>
        </div>
      </div>

      {/* Error Message */}
      <h3 className="text-xl font-semibold mb-3" style={{ color: 'rgb(239, 68, 68)' }}>
        Oops! Something went wrong
      </h3>
      
      <p className="text-gray-600 mb-6 max-w-md">
        {error || "We couldn't load the hiring requests. Please try again."}
      </p>

      {/* Action Buttons */}
      <div className="flex flex-col sm:flex-row gap-4">
        <button
          onClick={() => window.location.reload()}
          className="px-6 py-3 rounded-lg font-medium transition-all flex items-center justify-center gap-2"
          style={{ 
            backgroundColor: 'rgb(18, 76, 114)',
            color: 'white',
            boxShadow: '0 4px 6px -1px rgba(18, 76, 114, 0.2)'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = 'rgba(18, 76, 114, 0.9)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = 'rgb(18, 76, 114)';
          }}
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" 
                  d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
          </svg>
          Retry
        </button>
        
        <button
          onClick={() => {
            // You can implement contact support logic here
            console.log('Contact support clicked');
          }}
          className="px-6 py-3 rounded-lg font-medium transition-all border"
          style={{ 
            color: 'rgb(18, 76, 114)',
            borderColor: 'rgba(18, 76, 114, 0.3)',
            backgroundColor: 'white'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = 'rgba(18, 76, 114, 0.1)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = 'white';
          }}
        >
          Contact Support
        </button>
      </div>

      {/* Error Details (optional - for debugging) */}
      {process.env.NODE_ENV === 'development' && (
        <div className="mt-6 p-4 bg-gray-50 rounded-lg text-left max-w-md">
          <p className="text-xs font-mono text-gray-500 break-all">
            {error}
          </p>
        </div>
      )}
    </div>
  );
}

  const HiringSummary = ({ hiringRequests, DemandPlanning, departments }) => {

    const userRole = getToken();

  //  const restrictedDepartmentId = userRole?.department_id; // Assuming userRole has department_id if restricted
    const restrictedDepartmentId = getDepartmentIdFromToken();
    
    const filteredHiringRequests = userRole.IsDepartmentRestricted === "True"
      ? hiringRequests.filter(request =>Number( request.department_id) === Number(restrictedDepartmentId))
      : hiringRequests;
  
    const filteredDemandPlanning = userRole.IsDepartmentRestricted === "True"
      ? DemandPlanning.filter(dp => Number(dp.department_id) === Number(restrictedDepartmentId))
      : DemandPlanning;
  
    return (
      <div>


     {/* <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6   ">
     
  
  <FlipCard
    label="New Hiring Requests"
    count={filteredHiringRequests.filter(req => req.status === "Draft").length}
    imgSrc="themed_Hiring.svg"
  />
  <FlipCard
    label="Pending Approval Requests"
    count={filteredHiringRequests.filter(req => req.status === "Submitted").length}
    imgSrc="themed_Hiring.svg"
  />
  <FlipCard
    label="Approved Requests"
    count={filteredHiringRequests.filter(req => req.status === "Approved").length}
    imgSrc="themed_Hiring.svg"
  />
  <FlipCard
    label="Convert to Sourcing"
    count={filteredHiringRequests.filter(req => req.isConevrtToSource === true).length}
    imgSrc="themed_Hiring.svg"
  />
</div> */}

<div className="relative">
  {/* KPI Section */}
   <div className="xl:absolute z-10 w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-2 mb-8   sm:-top-6 lg:-top-[70px] md:px-[2.5%] lg:px-[2.5%] 3xl:px-[8%] 4xl:px-[10%] items-stretch">
    <FlipCard
      label="New Hiring "
    count={filteredHiringRequests.filter(req => req.status === "Draft").length}
      imgSrc="/total-request.svg"
    />
    <FlipCard
      label="Pending Approval"
      count={filteredHiringRequests.filter(req => req.status === "Submitted").length}
      imgSrc="/pending.svg"
    />
    <FlipCard
      label="Approved "
      count={filteredHiringRequests.filter(req => req.status === "Approved").length}
      imgSrc="/sourcing.svg"
    />
    <FlipCard
      label="Convert to Sourcing"
      count={filteredHiringRequests.filter(req => req.isConevrtToSource === true).length}
      imgSrc="/add-employee.svg"
    />

<div
  onClick={() => setIsCreateModalOpen(true)} // Changed from setIsFormVisible to setIsCreateModalOpen
  className="w-full bg-center bg-cover p-8 text-center rounded-2xl cursor-pointer"
  style={{ backgroundImage: `url('/add-bg.png')` }}
>
  <div className="flex flex-col gap-4 items-center">
    <img src="/add.svg" className="w-[40px]" alt="Add Icon" />
    <label className="font-bold text-xl text-white">Create New Request</label>
  </div>
</div>

  </div>
</div>


 </div>

    );
  };

   const customSelectStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: '#fff', // subtle light background matching header bg
    borderRadius: '0.75rem',    // rounded corners like your cards
    borderColor: state.isFocused ? '#ededed' : '#0D4A7650', // primary color on focus, gray default
    boxShadow: state.isFocused ? '0 0 0 1px #0D4A76' : 'none',
    padding: '2px 8px',
    cursor: 'pointer',
    minHeight: '38px',
  }),

   

  menu: (provided) => ({
    ...provided,
    borderRadius: '0.75rem',
    backgroundColor: 'white',
    boxShadow: '0 4px 10px rgba(131,117,80,0.15)', // subtle shadow with your theme color
    zIndex: 1000,
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? '#f9f7e8' : 'white', // hover background like your rows
    color: '#837550',
    cursor: 'pointer',
    padding: '8px 12px',
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#837550',
    fontWeight: '600',
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: '#837550',
    ':hover': {
      color: '#b5a252',
    },
  }),
  indicatorSeparator: () => ({ display: 'none' }),
};
  return (
     <>
 <HiringSummary 
        hiringRequests={hiringRequests} 
        DemandPlanning={DemandPlanning} 
 
        departments={departments} 
      />
    
   <div className="flex flex-col  2xl:px-[10%] pt-8 bg-white xl:pt-24 md:pt-8 md:rounded-t-[40px] xl:rounded-t-[48px] mx-4 h-[70vh] sm:h-[72vh] md:h-[74.5vh] lg:h-[74.5vh] xl:px-[calc(8%-1rem)] 3xl:px-[calc(8%-1rem)] 4xl:px-[calc(10%-1rem)] md:px-[calc(5%-1rem)]">
       
      {/* Top Panels */}
      
 
   
  
     <div className="bg-white rounded-2xl p-6   filter drop-shadow-[0_5px_30px_rgba(10,60,96,0.10)]   ">
   <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-6">
  <h3 className="text-xl sm:text-2xl font-semibold" style={{ color: 'rgb(18, 76, 114)' }}>
    Request Details
  </h3>

  {/* Add relative and z-index to filters container */}
  <div className="flex flex-wrap items-center gap-3 relative z-[100]">
    
    {/* Department Dropdown */}
    <div className="relative ">
      <Select
        options={[
          { value: 'all', label: 'Select Department' },
          ...departments.map((d) => ({
            value: d.department_id,
            label: d.department_name,
          })),
        ]}
        value={
          selectedDepartment === 'all'
            ? { value: 'all', label: 'Select Department' }
            : {
                value: selectedDepartment,
                label: departments.find((d) => d.department_id === selectedDepartment)?.department_name,
              }
        }
        onChange={(option) => setSelectedDepartment(option.value)}
        placeholder="Select Department"
        className="min-w-[180px]"
        styles={{
          control: (base, state) => ({
            ...base,
            borderColor: state.isFocused ? 'rgb(18, 76, 114)' : 'rgba(18, 76, 114, 0.3)',
            borderRadius: '0.75rem',
            minHeight: '42px',
            fontSize: '14px',
            boxShadow: state.isFocused ? '0 0 0 2px rgba(18, 76, 114, 0.2)' : 'none',
            '&:hover': {
              borderColor: 'rgb(18, 76, 114)'
            }
          }),
          menu: (provided) => ({
            ...provided,
            zIndex: 9999,
            position: 'absolute',
          }),
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          dropdownIndicator: (base) => ({
            ...base,
            padding: '0 8px',
          }),
          placeholder: (base) => ({
            ...base,
            color: '#6B7280'
          }),
          singleValue: (base) => ({
            ...base,
            color: 'rgb(18, 76, 114)'
          })
        }}
        menuPortalTarget={document.body}
        menuPosition="fixed"
        aria-label="Select Department"
      />
    </div>

    {/* Year Dropdown */}
    <div className="relative z-[9998]">
      <Select
        options={yearOptions}
        value={yearOptions.find((opt) => opt.value === selectedYear)}
        onChange={(option) => setSelectedYear(option.value)}
        placeholder="Select Year"
        className="min-w-[140px]"
        styles={{
          control: (base, state) => ({
            ...base,
            borderColor: state.isFocused ? 'rgb(18, 76, 114)' : 'rgba(18, 76, 114, 0.3)',
            borderRadius: '0.75rem',
            minHeight: '42px',
            fontSize: '14px',
            boxShadow: state.isFocused ? '0 0 0 2px rgba(18, 76, 114, 0.2)' : 'none',
            '&:hover': {
              borderColor: 'rgb(18, 76, 114)'
            }
          }),
          menu: (provided) => ({
            ...provided,
            zIndex: 9999,
            position: 'absolute',
          }),
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          placeholder: (base) => ({
            ...base,
            color: '#6B7280'
          }),
          singleValue: (base) => ({
            ...base,
            color: 'rgb(18, 76, 114)'
          })
        }}
        menuPortalTarget={document.body}
        menuPosition="fixed"
        aria-label="Select Year"
      />
    </div>

    {/* Status Dropdown */}
    <div className="relative z-[9997]">
      <Select
        options={[
          { value: 'all', label: 'Select Status' },
          { value: 'Draft', label: 'Draft' },
          { value: 'Submitted', label: 'Submitted' },
          { value: 'Approved', label: 'Approved' },
          { value: 'Rejected', label: 'Rejected' },
          { value: 'On Hold', label: 'On Hold' },
          { value: 'Sourcing', label: 'Sourcing' },
          { value: 'Shortlisting', label: 'Shortlisting' },
          { value: 'Shortlisted', label: 'Shortlisted' },
          { value: 'Interviewing ', label: 'Interviewing' },
          { value: 'Hiring Approvals', label: 'Hiring Approvals' },
          { value: 'Offering', label: 'Offering' },
          { value: 'Joining', label: 'Joining' },
          { value: 'Joined', label: 'Joined' },
        ]}
        value={
          selectedStatus === 'all'
            ? { value: 'all', label: 'Select Status' }
            : { value: selectedStatus, label: selectedStatus }
        }
        onChange={(option) => setSelectedStatus(option.value)}
        placeholder="Select Status"
        className="min-w-[140px]"
        styles={{
          control: (base, state) => ({
            ...base,
            borderColor: state.isFocused ? 'rgb(18, 76, 114)' : 'rgba(18, 76, 114, 0.3)',
            borderRadius: '0.75rem',
            minHeight: '42px',
            fontSize: '14px',
            boxShadow: state.isFocused ? '0 0 0 2px rgba(18, 76, 114, 0.2)' : 'none',
            '&:hover': {
              borderColor: 'rgb(18, 76, 114)'
            }
          }),
          menu: (provided) => ({
            ...provided,
            zIndex: 9999,
            position: 'absolute',
          }),
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          placeholder: (base) => ({
            ...base,
            color: '#6B7280'
          }),
          singleValue: (base) => ({
            ...base,
            color: 'rgb(18, 76, 114)'
          })
        }}
        menuPortalTarget={document.body}
        menuPosition="fixed"
        aria-label="Select Status"
      />
    </div>

    {/* Sourcing Dropdown */}
    <div className="relative z-[9996]">
      <Select
        options={[
          { value: 'all', label: 'Select Sourcing' },
          { value: 'YES', label: 'Yes' },
          { value: 'NO', label: 'No' },
        ]}
        value={
          selectedSourcing === 'all'
            ? { value: 'all', label: 'Select Sourcing' }
            : { value: selectedSourcing, label: selectedSourcing === 'YES' ? 'Yes' : 'No' }
        }
        onChange={(option) => setSelectedSourcing(option.value)}
        placeholder="Select Sourcing"
        className="min-w-[140px]"
        styles={{
          control: (base, state) => ({
            ...base,
            borderColor: state.isFocused ? 'rgb(18, 76, 114)' : 'rgba(18, 76, 114, 0.3)',
            borderRadius: '0.75rem',
            minHeight: '42px',
            fontSize: '14px',
            boxShadow: state.isFocused ? '0 0 0 2px rgba(18, 76, 114, 0.2)' : 'none',
            '&:hover': {
              borderColor: 'rgb(18, 76, 114)'
            }
          }),
          menu: (provided) => ({
            ...provided,
            zIndex: 9999,
            position: 'absolute',
          }),
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          placeholder: (base) => ({
            ...base,
            color: '#6B7280'
          }),
          singleValue: (base) => ({
            ...base,
            color: 'rgb(18, 76, 114)'
          })
        }}
        menuPortalTarget={document.body}
        menuPosition="fixed"
        aria-label="Select Sourcing"
      />
    </div>

    {/* Items Per Page - Add container with z-index */}
    <div className="relative z-[50]">
      <select
        value={itemsPerPage}
        onChange={(e) => {
          setItemsPerPage(Number(e.target.value));
          setCurrentPage(1);
        }}
        className="min-w-[120px] px-3 py-2.5 border rounded-xl outline-none transition text-sm"
        style={{
          color: 'rgb(18, 76, 114)',
          borderColor: 'rgba(18, 76, 114, 0.3)',
          backgroundColor: 'white'
        }}
        onFocus={(e) => {
          e.target.style.boxShadow = '0 0 0 2px rgba(18, 76, 114, 0.2)';
          e.target.style.borderColor = 'rgb(18, 76, 114)';
        }}
        onBlur={(e) => {
          e.target.style.boxShadow = 'none';
          e.target.style.borderColor = 'rgba(18, 76, 114, 0.3)';
        }}
      >
        {[5, 10, 20, 50].map((count) => (
          <option key={count} value={count} style={{ color: 'rgb(18, 76, 114)' }}>
            {count} / Page
          </option>
        ))}
      </select>
    </div>

    {/* Search Input */}
    <div className="relative flex-1 min-w-[200px] z-[50]">
      <input
        type="text"
        className="w-full px-4 py-2.5 border rounded-xl outline-none transition text-sm pl-10"
        style={{
          color: 'rgb(18, 76, 114)',
          borderColor: 'rgba(18, 76, 114, 0.3)',
          backgroundColor: 'white'
        }}
        onFocus={(e) => {
          e.target.style.boxShadow = '0 0 0 2px rgba(18, 76, 114, 0.2)';
          e.target.style.borderColor = 'rgb(18, 76, 114)';
        }}
        onBlur={(e) => {
          e.target.style.boxShadow = 'none';
          e.target.style.borderColor = 'rgba(18, 76, 114, 0.3)';
        }}
        placeholder="Search roles or descriptions..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
      />
      <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
        <svg className="w-4 h-4" style={{ color: 'rgba(18, 76, 114, 0.5)' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
        </svg>
      </div>
    </div>

    {/* Clear Filters Button */}
    <button
      onClick={resetFilters}
      className="px-4 py-2.5 text-sm font-medium rounded-xl transition-all z-[50]"
      style={{
        color: 'rgb(18, 76, 114)',
        backgroundColor: 'white',
        border: '1px solid rgba(18, 76, 114, 0.3)'
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = 'rgba(18, 76, 114, 0.1)';
        e.currentTarget.style.borderColor = 'rgb(18, 76, 114)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = 'white';
        e.currentTarget.style.borderColor = 'rgba(18, 76, 114, 0.3)';
      }}
      aria-label="Clear Filters"
    >
      Clear Filters
    </button>
  </div>
</div>

 
 

 
  

    
 









      {/* Add New Request Button */}
     

      {/* Hiring Table */}
   <div className="bg-white p-4 rounded-2xl shadow-sm border" style={{ borderColor: 'rgba(18, 76, 114, 0.1)' }}>
  <div className="rounded-xl border" style={{ 
  borderColor: 'rgba(18, 76, 114, 0.1)',
  backgroundColor: 'white',
  boxShadow: '0 4px 20px rgba(18, 76, 114, 0.1)'
}}>
  <table className="min-w-full">
    <thead>
      <tr style={{ 
        backgroundColor: 'rgba(18, 76, 114, 0.05)'
      }}>
        <th className="py-3 px-4 text-sm font-semibold text-left border-b" style={{ 
          borderColor: 'rgba(18, 76, 114, 0.1)',
          color: 'rgb(18, 76, 114)'
        }}>Reference Number</th>
        <th className="py-3 px-4 text-sm font-semibold text-left border-b" style={{ 
          borderColor: 'rgba(18, 76, 114, 0.1)',
          color: 'rgb(18, 76, 114)'
        }}>Req Type</th>
        <th className="py-3 px-4 text-sm font-semibold text-left border-b" style={{ 
          borderColor: 'rgba(18, 76, 114, 0.1)',
          color: 'rgb(18, 76, 114)'
        }}>Department</th>
        <th className="py-3 px-4 text-sm font-semibold text-left border-b" style={{ 
          borderColor: 'rgba(18, 76, 114, 0.1)',
          color: 'rgb(18, 76, 114)'
        }}>Year</th>
        <th className="py-3 px-4 text-sm font-semibold text-left border-b" style={{ 
          borderColor: 'rgba(18, 76, 114, 0.1)',
          color: 'rgb(18, 76, 114)'
        }}>Role</th>
        <th className="py-3 px-4 text-sm font-semibold text-left border-b" style={{ 
          borderColor: 'rgba(18, 76, 114, 0.1)',
          color: 'rgb(18, 76, 114)'
        }}>Position</th>
        <th className="py-3 px-4 text-sm font-semibold text-left border-b" style={{ 
          borderColor: 'rgba(18, 76, 114, 0.1)',
          color: 'rgb(18, 76, 114)'
        }}>Hire Manager</th>
        <th className="py-3 px-4 text-sm font-semibold text-left border-b" style={{ 
          borderColor: 'rgba(18, 76, 114, 0.1)',
          color: 'rgb(18, 76, 114)'
        }}>Req Date</th>
        <th className="py-3 px-4 text-sm font-semibold text-left border-b" style={{ 
          borderColor: 'rgba(18, 76, 114, 0.1)',
          color: 'rgb(18, 76, 114)'
        }}>Status</th>
        <th className="py-3 px-4 text-sm font-semibold text-left border-b" style={{ 
          borderColor: 'rgba(18, 76, 114, 0.1)',
          color: 'rgb(18, 76, 114)'
        }}>Priority</th>
        <th className="py-3 px-4 text-sm font-semibold text-left border-b" style={{ 
          borderColor: 'rgba(18, 76, 114, 0.1)',
          color: 'rgb(18, 76, 114)'
        }}>IsNew</th>
        <th className="py-3 px-4 text-sm font-semibold text-left border-b" style={{ 
          borderColor: 'rgba(18, 76, 114, 0.1)',
          color: 'rgb(18, 76, 114)'
        }}>Actions</th>
      </tr>
    </thead>
    <tbody>
      {paginatedRequests.length === 0 ? (
        <tr>
          <td colSpan="12" className="py-12 text-center">
            <div className="flex flex-col items-center justify-center">
              <svg className="w-12 h-12 mb-4" style={{ color: 'rgba(18, 76, 114, 0.3)' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              <p className="text-sm font-medium mb-1" style={{ color: 'rgb(18, 76, 114)' }}>
                No requests found
              </p>
              <p className="text-xs" style={{ color: 'rgba(18, 76, 114, 0.7)' }}>
                No requests match your current filters. Try adjusting your search or filters.
              </p>
            </div>
          </td>
        </tr>
      ) : (
        paginatedRequests.map((request, index) => {
          const department = departments.find(dept => Number(dept.department_id) === Number(request.department_id))?.department_name;
          const hiringManager = hiringManagers.find(manager => Number(manager.user_id) === Number(request.hiring_manager))?.first_name;
          const roles = request.request_type === "Forecast"
            ? DemandPlanning.find(manager => Number(manager.demand_id) === Number(request.demand_id))?.role
            : request.role_text;

          // Status badge colors with your primary color variations
          const statusColors = {
            'Draft': { bg: 'rgba(59, 130, 246, 0.1)', text: 'rgb(37, 99, 235)' },
            'Submitted': { bg: 'rgba(30, 64, 175, 0.1)', text: 'rgb(30, 64, 175)' },
            'Approved': { bg: 'rgba(16, 185, 129, 0.1)', text: 'rgb(5, 150, 105)' },
            'Rejected': { bg: 'rgba(239, 68, 68, 0.1)', text: 'rgb(220, 38, 38)' },
            'On Hold': { bg: 'rgba(245, 158, 11, 0.1)', text: 'rgb(217, 119, 6)' },
            'Sourcing': { bg: 'rgba(129, 140, 248, 0.1)', text: 'rgb(99, 102, 241)' },
            'Shortlisting': { bg: 'rgba(139, 92, 246, 0.1)', text: 'rgb(124, 58, 237)' },
            'Shortlisted': { bg: 'rgba(168, 85, 247, 0.1)', text: 'rgb(147, 51, 234)' },
            'Interviewing': { bg: 'rgba(14, 165, 233, 0.1)', text: 'rgb(2, 132, 199)' },
            'Hiring Approvals': { bg: 'rgba(34, 197, 94, 0.1)', text: 'rgb(21, 128, 61)' },
            'Offering': { bg: 'rgba(249, 115, 22, 0.1)', text: 'rgb(234, 88, 12)' },
            'Joining': { bg: 'rgba(245, 158, 11, 0.1)', text: 'rgb(217, 119, 6)' },
            'Joined': { bg: 'rgba(16, 185, 129, 0.1)', text: 'rgb(5, 150, 105)' }
          };
          
          const statusStyle = statusColors[request.status] || { bg: 'rgba(18, 76, 114, 0.1)', text: 'rgb(18, 76, 114)' };

          return (
            <tr 
              key={request.request_id} 
              className={`${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'} hover:bg-gray-100 transition-colors`}
            >
              {/* Reference Number */}
              <td className="py-3 px-4 border-t text-sm" style={{ 
                borderColor: 'rgba(18, 76, 114, 0.1)',
                color: 'rgba(18, 76, 114, 0.9)'
              }}>
                {request.referenceNumber} 
              </td>

              {/* Request Type */}
              <td className="py-3 px-4 border-t text-sm" style={{ 
                borderColor: 'rgba(18, 76, 114, 0.1)',
                color: 'rgba(18, 76, 114, 0.9)'
              }}>
                {request.request_type}
              </td>

              {/* Department */}
              <td className="py-3 px-4 border-t text-sm" style={{ 
                borderColor: 'rgba(18, 76, 114, 0.1)',
                color: 'rgba(18, 76, 114, 0.9)'
              }}>
                {department}
              </td>

              {/* Year */}
              <td className="py-3 px-4 border-t text-sm" style={{ 
                borderColor: 'rgba(18, 76, 114, 0.1)',
                color: 'rgba(18, 76, 114, 0.9)'
              }}>
                {request.years}
              </td>

              {/* Role */}
              <td className="py-3 px-4 border-t text-sm" style={{ 
                borderColor: 'rgba(18, 76, 114, 0.1)',
                color: 'rgba(18, 76, 114, 0.9)'
              }}>
                {roles} 
              </td>

              {/* Position */}
              <td className="py-3 px-4 border-t text-sm" style={{ 
                borderColor: 'rgba(18, 76, 114, 0.1)',
                color: 'rgba(18, 76, 114, 0.9)'
              }}>
                {request.position}
              </td>

              {/* Hiring Manager */}
              <td className="py-3 px-4 border-t text-sm" style={{ 
                borderColor: 'rgba(18, 76, 114, 0.1)',
                color: 'rgba(18, 76, 114, 0.9)'
              }}>
                {hiringManager}
              </td>

              {/* Request Date */}
              <td className="py-3 px-4 border-t text-sm" style={{ 
                borderColor: 'rgba(18, 76, 114, 0.1)',
                color: 'rgba(18, 76, 114, 0.9)'
              }}>
                {new Date(request.date_created).toLocaleDateString()}
              </td>

              {/* Status */}
              <td className="py-3 px-4 border-t" style={{ 
                borderColor: 'rgba(18, 76, 114, 0.1)'
              }}>
                <span 
                  className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium"
                  style={{
                    backgroundColor: statusStyle.bg,
                    color: statusStyle.text
                  }}
                >
                  {request.status}
                </span>
              </td>

              {/* Priority */}
              <td className="py-3 px-4 border-t text-sm" style={{ 
                borderColor: 'rgba(18, 76, 114, 0.1)',
                color: 'rgba(18, 76, 114, 0.9)'
              }}>
                {request.priority}
              </td>

              {/* IsNew (Hiring Type) */}
              <td className="py-3 px-4 border-t text-sm" style={{ 
                borderColor: 'rgba(18, 76, 114, 0.1)',
                color: 'rgba(18, 76, 114, 0.9)'
              }}>
                {request.hiring_Type}
              </td>

              {/* Actions */}
              <td className="py-3 px-4 border-t" style={{ 
                borderColor: 'rgba(18, 76, 114, 0.1)'
              }}>
                <div className="relative">
                  <button
                    onClick={(e) => { e.stopPropagation(); toggleMenu(request.request_id); }}
                    className="px-3 py-1.5 rounded text-sm transition-colors flex items-center gap-1.5"
                    style={{ 
                      backgroundColor: 'rgba(18, 76, 114, 0.1)',
                      color: 'rgb(18, 76, 114)'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = 'rgba(18, 76, 114, 0.2)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = 'rgba(18, 76, 114, 0.1)';
                    }}
                  >
                    <span>Actions</span>
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>

                  {openRequestId === request.request_id && (
                    <div 
                      ref={dropdownRef} 
                      className="absolute right-0 mt-1 bg-white border rounded-lg shadow-lg z-[99999] min-w-[200px]"
                      style={{ 
                        borderColor: 'rgba(18, 76, 114, 0.1)',
                        boxShadow: '0 4px 20px rgba(18, 76, 114, 0.15)'
                      }}
                    >
                      <div className="py-1">
                        {/* View Request */}
                        <button
                          onClick={() => handleView(request.request_id)}
                          className="w-full text-left px-4 py-2 text-sm transition-all hover:bg-gray-50 flex items-center gap-3"
                          style={{ color: 'rgb(18, 76, 114)' }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = 'rgba(18, 76, 114, 0.1)';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = 'transparent';
                          }}
                        >
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                          </svg>
                          View Request
                        </button>

                        {/* Edit Request - Draft status only */}
                        {request.status === 'Draft' && (
                          <button
                            onClick={() => handleEdit(request.request_id)}
                            className="w-full text-left px-4 py-2 text-sm transition-all hover:bg-gray-50 flex items-center gap-3"
                            style={{ color: 'rgb(18, 76, 114)' }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = 'rgba(18, 76, 114, 0.1)';
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor = 'transparent';
                            }}
                          >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                            </svg>
                            Edit Request
                          </button>
                        )}

                        {/* Approve - Submitted status for non-restricted users */}
                        {(request.status === 'Submitted' && userRole.IsDepartmentRestricted === "False") && (
                          <button
                            onClick={() => handleApprove(request.request_id)}
                            className="w-full text-left px-4 py-2 text-sm transition-all hover:bg-gray-50 flex items-center gap-3"
                            style={{ color: 'rgb(18, 76, 114)' }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = 'rgba(18, 76, 114, 0.1)';
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor = 'transparent';
                            }}
                          >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                            </svg>
                            Approve Request
                          </button>
                        )}

                        {/* Un Hold - On Hold status for non-restricted users */}
                        {(request.status === 'On Hold' && userRole.IsDepartmentRestricted === "False") && (
                          <button
                            onClick={() => handleUnHold(request.request_id)}
                            className="w-full text-left px-4 py-2 text-sm transition-all hover:bg-gray-50 flex items-center gap-3"
                            style={{ color: 'rgb(18, 76, 114)' }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = 'rgba(18, 76, 114, 0.1)';
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor = 'transparent';
                            }}
                          >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            Un Hold Request
                          </button>
                        )}

                        {/* Hold - Approved/Submitted status for non-restricted users */}
                        {((request.status === 'Approved' || request.status === 'Submitted') && userRole.IsDepartmentRestricted === "False" && Boolean(request.isConevrtToSource) === false) && (
                          <button
                            onClick={() => handleHold(request.request_id)}
                            className="w-full text-left px-4 py-2 text-sm transition-all hover:bg-gray-50 flex items-center gap-3"
                            style={{ color: 'rgb(18, 76, 114)' }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = 'rgba(18, 76, 114, 0.1)';
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor = 'transparent';
                            }}
                          >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                            </svg>
                            Hold Request
                          </button>
                        )}

                        {/* Convert to Sourcing - Approved status for non-restricted users */}
                        {request.status === 'Approved' && userRole.IsDepartmentRestricted === "False" && Boolean(request.isConevrtToSource) === false && (
                          <button
                            onClick={() => handleConvertClick(request.request_id)}
                            className="w-full text-left px-4 py-2 text-sm transition-all hover:bg-gray-50 flex items-center gap-3"
                            style={{ color: 'rgb(18, 76, 114)' }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = 'rgba(18, 76, 114, 0.1)';
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor = 'transparent';
                            }}
                          >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                            </svg>
                            Convert to Sourcing
                          </button>
                        )}

                        {/* Send for Approval - Draft status only */}
                        {request.status === 'Draft' && (
                          <button
                            onClick={() => handleSendApprove(request.request_id)}
                            className="w-full text-left px-4 py-2 text-sm transition-all hover:bg-gray-50 flex items-center gap-3"
                            style={{ color: 'rgb(18, 76, 114)' }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = 'rgba(18, 76, 114, 0.1)';
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor = 'transparent';
                            }}
                          >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
                            </svg>
                            Send for Approval
                          </button>
                        )}

                        {/* Reject - Draft status or Submitted for non-restricted users */}
                        {(request.status === 'Draft' || (request.status === 'Submitted' && userRole.IsDepartmentRestricted !== "True")) && (
                          <button
                            onClick={() => handleReject(request.request_id)}
                            className="w-full text-left px-4 py-2 text-sm transition-all hover:bg-gray-50 flex items-center gap-3"
                            style={{ color: 'rgb(220, 38, 38)' }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = 'rgba(220, 38, 38, 0.1)';
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor = 'transparent';
                            }}
                          >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                            Reject Request
                          </button>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </td>
            </tr>
          );
        })
      )}
    </tbody>
  </table>

  {/* Pagination */}
  {totalPages > 1 && (
    <div className="flex flex-col sm:flex-row items-center justify-between gap-4 mt-6 pt-6 border-t px-4" style={{ 
      borderColor: 'rgba(18, 76, 114, 0.1)'
    }}>
      <div className="text-sm" style={{ color: 'rgba(18, 76, 114, 0.7)' }}>
        Showing <span className="font-semibold">{startIndex + 1}-{endIndex}</span> of <span className="font-semibold">{paginatedRequests.length}</span> results
      </div>
      <div className="flex items-center gap-2">
        <button
          onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
          disabled={currentPage === 1}
          className="px-3 py-1 rounded border text-sm transition-colors disabled:opacity-50"
          style={{ 
            borderColor: 'rgba(18, 76, 114, 0.3)',
            color: 'rgb(18, 76, 114)'
          }}
        >
          Previous
        </button>
        {Array.from({ length: Math.min(totalPages, 5) }).map((_, idx) => {
          const pageNum = currentPage <= 3 ? idx + 1 : 
                        currentPage >= totalPages - 2 ? totalPages - 4 + idx :
                        currentPage - 2 + idx;
          if (pageNum < 1 || pageNum > totalPages) return null;
          return (
            <button
              key={pageNum}
              onClick={() => setCurrentPage(pageNum)}
              className={`px-3 py-1 rounded text-sm transition-colors ${currentPage === pageNum ? 'font-semibold' : ''}`}
              style={{ 
                backgroundColor: currentPage === pageNum ? 'rgb(18, 76, 114)' : 'transparent',
                color: currentPage === pageNum ? 'white' : 'rgb(18, 76, 114)',
                border: currentPage === pageNum ? 'none' : '1px solid rgba(18, 76, 114, 0.3)'
              }}
            >
              {pageNum}
            </button>
          );
        })}
        <button
          onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
          disabled={currentPage === totalPages}
          className="px-3 py-1 rounded border text-sm transition-colors disabled:opacity-50"
          style={{ 
            borderColor: 'rgba(18, 76, 114, 0.3)',
            color: 'rgb(18, 76, 114)'
          }}
        >
          Next
        </button>
      </div>
    </div>
  )}
</div>
    </div>



</div>
      {/* New Hiring Request Form */}
  
{isModalVisible && selectedRequest && (
  <div className="fixed inset-0 backdrop-blur-sm flex justify-center items-center z-[50]  p-2 sm:p-4" style={{ backgroundColor: 'rgba(18, 76, 114, 0.2)' }}>
    <div 
      className="relative bg-white rounded-2xl shadow-2xl flex flex-col w-full max-w-full sm:max-w-xl md:max-w-2xl lg:max-w-3xl xl:max-w-4xl 2xl:max-w-5xl "
      style={{ 
        borderColor: 'rgba(18, 76, 114, 0.1)', 
        borderWidth: '1px',
         
      }}
    >
      {/* Modal Header - Fixed height */}
      <div className="flex-shrink-0 flex items-center justify-between p-4 sm:p-6 border-b rounded-t-2xl" style={{ 
        borderColor: 'rgba(18, 76, 114, 0.1)',
        background: 'linear-gradient(to right, rgba(18, 76, 114, 0.05), transparent)',
        minHeight: '64px'
      }}>
        <h2 className="text-lg sm:text-xl font-semibold truncate" style={{ color: 'rgb(18, 76, 114)' }}>
          {isApproveMode
            ? 'Approval Hiring Request'
            : isEditMode
            ? 'Edit Hiring Request'
            : isSendApproveMode
            ? 'Send Request Details'
            : isUnHoldMode
            ? 'Un Hold Request Details'
            : isHoldMode
            ? 'Hold Request Details'
            : isPlanDate
            ? 'Update Plan Date'
            : IsRejecMode
            ? 'Reject Request Details'
            : 'Request Details'}
        </h2>
        <button 
          onClick={closeModal}
          className="flex-shrink-0 transition-all rounded-full p-1 sm:p-1.5 ml-2"
          style={{ color: 'rgba(18, 76, 114, 0.6)' }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = 'rgb(18, 76, 114)';
            e.currentTarget.style.color = 'white';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = 'transparent';
            e.currentTarget.style.color = 'rgba(18, 76, 114, 0.6)';
          }}
          aria-label="Close"
        >
          <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      {/* Modal Body - Flexible height with proper scrolling */}
      <div className="flex-1 overflow-hidden">
        {/* Tabs */}
        <div className="px-4 sm:px-6 pt-4 pb-2">
          <div className="border-b" style={{ borderColor: 'rgba(18, 76, 114, 0.1)' }}>
            <nav className="flex gap-1 -mb-px">
              {['details', 'jd'].map((tab) => (
                <button
                  key={tab}
                  className={`px-3 py-1.5 font-medium text-xs sm:text-sm rounded-t-lg transition-all duration-300 ${
                    activeTab === tab
                      ? 'text-white'
                      : 'text-primary-800 hover:text-primary-600'
                  }`}
                  style={{
                    backgroundColor: activeTab === tab ? 'rgb(18, 76, 114)' : 'transparent',
                    borderColor: activeTab === tab ? 'rgb(18, 76, 114)' : 'transparent',
                  }}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab === 'details' ? 'Details' : 'Job Description'}
                </button>
              ))}
            </nav>
          </div>
        </div>

        {/* Scrollable Content Area */}
        <div className="h-full overflow-y-auto px-4 sm:px-6 pb-4">
          {activeTab === 'details' && (
            <div className="grid grid-cols-1 md:grid-cols-3 gap-3 sm:gap-4">
              {/* Reference Number */}
              <div className="space-y-1">
                <label className="block text-xs sm:text-sm font-medium" style={{ color: 'rgb(18, 76, 114)' }}>
                  Reference Number
                </label>
                <div className="px-2 sm:px-3 py-1.5 sm:py-2 border rounded-lg" style={{ 
                  borderColor: 'rgba(18, 76, 114, 0.2)',
                  backgroundColor: 'rgba(18, 76, 114, 0.03)'
                }}>
                  <span className="text-gray-800 text-sm font-medium break-words">{selectedRequest.referenceNumber}</span>
                </div>
              </div>

              {/* Request Type */}
              <div className="space-y-1">
                <label className="block text-xs sm:text-sm font-medium" style={{ color: 'rgb(18, 76, 114)' }}>
                  Request Type
                </label>
                {isEditMode ? (
                  <select
                    className="w-full px-2 sm:px-3 py-1.5 sm:py-2 border rounded-lg outline-none transition text-sm text-gray-700"
                    style={{ 
                      borderColor: 'rgba(18, 76, 114, 0.3)',
                      backgroundColor: 'white'
                    }}
                    onFocus={(e) => {
                      e.target.style.boxShadow = '0 0 0 2px rgba(18, 76, 114, 0.2)';
                      e.target.style.borderColor = 'rgb(18, 76, 114)';
                    }}
                    onBlur={(e) => {
                      e.target.style.boxShadow = 'none';
                      e.target.style.borderColor = 'rgba(18, 76, 114, 0.3)';
                    }}
                    value={selectedRequest.request_type}
                    onChange={(e) =>
                      setSelectedRequest({ ...selectedRequest, request_type: e.target.value })
                    }
                  >
                    <option value="Forecast">Forecast</option>
                    <option value="Exceptional">Exceptional</option>
                  </select>
                ) : (
                  <div className="px-2 sm:px-3 py-1.5 sm:py-2 border rounded-lg" style={{ 
                    borderColor: 'rgba(18, 76, 114, 0.2)',
                    backgroundColor: 'rgba(18, 76, 114, 0.03)'
                  }}>
                    <span className="text-gray-800 text-sm font-medium">{selectedRequest.request_type}</span>
                  </div>
                )}
              </div>

              {/* Department */}
              <div className="space-y-1">
                <label className="block text-xs sm:text-sm font-medium" style={{ color: 'rgb(18, 76, 114)' }}>
                  Department
                </label>
                {isEditMode ? (
                  <select
                    className="w-full px-2 sm:px-3 py-1.5 sm:py-2 border rounded-lg outline-none transition text-sm text-gray-700"
                    style={{ 
                      borderColor: 'rgba(18, 76, 114, 0.3)',
                      backgroundColor: 'white'
                    }}
                    onFocus={(e) => {
                      e.target.style.boxShadow = '0 0 0 2px rgba(18, 76, 114, 0.2)';
                      e.target.style.borderColor = 'rgb(18, 76, 114)';
                    }}
                    onBlur={(e) => {
                      e.target.style.boxShadow = 'none';
                      e.target.style.borderColor = 'rgba(18, 76, 114, 0.3)';
                    }}
                    value={selectedRequest.department_id}
                    onChange={(e) =>
                      setSelectedRequest({ ...selectedRequest, department_id: e.target.value })
                    }
                  >
                    {departments.map(dept => (
                      <option key={dept.department_id} value={dept.department_id}>
                        {dept.department_name}
                      </option>
                    ))}
                  </select>
                ) : (
                  <div className="px-2 sm:px-3 py-1.5 sm:py-2 border rounded-lg" style={{ 
                    borderColor: 'rgba(18, 76, 114, 0.2)',
                    backgroundColor: 'rgba(18, 76, 114, 0.03)'
                  }}>
                    <span className="text-gray-800 text-sm font-medium">
                      {departments.find(dept => Number(dept.department_id) === Number(selectedRequest.department_id))?.department_name}
                    </span>
                  </div>
                )}
              </div>

              {/* Role */}
              <div className="space-y-1">
                <label className="block text-xs sm:text-sm font-medium" style={{ color: 'rgb(18, 76, 114)' }}>
                  Role
                </label>
                <div className="px-2 sm:px-3 py-1.5 sm:py-2 border rounded-lg" style={{ 
                  borderColor: 'rgba(18, 76, 114, 0.2)',
                  backgroundColor: 'rgba(18, 76, 114, 0.03)'
                }}>
                  <span className="text-gray-800 text-sm font-medium">
                    {selectedRequest.request_type === "Forecast"
                      ? DemandPlanning.find(manager => Number(manager.demand_id) === Number(selectedRequest.demand_id))?.role || "N/A"
                      : selectedRequest.role_text || "N/A"}
                  </span>
                </div>
              </div>

              {/* Position */}
              <div className="space-y-1">
                <label className="block text-xs sm:text-sm font-medium" style={{ color: 'rgb(18, 76, 114)' }}>
                  Position
                </label>
                {isEditMode ? (
                  <input
                    type="text"
                    className="w-full px-2 sm:px-3 py-1.5 sm:py-2 border rounded-lg outline-none transition text-sm text-gray-700"
                    style={{ 
                      borderColor: 'rgba(18, 76, 114, 0.3)',
                      backgroundColor: 'white'
                    }}
                    onFocus={(e) => {
                      e.target.style.boxShadow = '0 0 0 2px rgba(18, 76, 114, 0.2)';
                      e.target.style.borderColor = 'rgb(18, 76, 114)';
                    }}
                    onBlur={(e) => {
                      e.target.style.boxShadow = 'none';
                      e.target.style.borderColor = 'rgba(18, 76, 114, 0.3)';
                    }}
                    value={selectedRequest.position}
                    onChange={(e) =>
                      setSelectedRequest({ ...selectedRequest, position: e.target.value })
                    }
                  />
                ) : (
                  <div className="px-2 sm:px-3 py-1.5 sm:py-2 border rounded-lg" style={{ 
                    borderColor: 'rgba(18, 76, 114, 0.2)',
                    backgroundColor: 'rgba(18, 76, 114, 0.03)'
                  }}>
                    <span className="text-gray-800 text-sm font-medium">{selectedRequest.position}</span>
                  </div>
                )}
              </div>

              {/* Hiring Manager */}
              <div className="space-y-1">
                <label className="block text-xs sm:text-sm font-medium" style={{ color: 'rgb(18, 76, 114)' }}>
                  Hiring Manager
                </label>
                {isEditMode ? (
                  <select
                    className="w-full px-2 sm:px-3 py-1.5 sm:py-2 border rounded-lg outline-none transition text-sm text-gray-700"
                    style={{ 
                      borderColor: 'rgba(18, 76, 114, 0.3)',
                      backgroundColor: 'white'
                    }}
                    onFocus={(e) => {
                      e.target.style.boxShadow = '0 0 0 2px rgba(18, 76, 114, 0.2)';
                      e.target.style.borderColor = 'rgb(18, 76, 114)';
                    }}
                    onBlur={(e) => {
                      e.target.style.boxShadow = 'none';
                      e.target.style.borderColor = 'rgba(18, 76, 114, 0.3)';
                    }}
                    value={selectedRequest.hiring_manager}
                    onChange={(e) =>
                      setSelectedRequest({ ...selectedRequest, hiring_manager: e.target.value })
                    }
                  >
                    {hiringManagers.map(manager => (
                      <option key={manager.user_id} value={manager.user_id}>
                        {manager.first_name} {manager.last_name}
                      </option>
                    ))}
                  </select>
                ) : (
                  <div className="px-2 sm:px-3 py-1.5 sm:py-2 border rounded-lg" style={{ 
                    borderColor: 'rgba(18, 76, 114, 0.2)',
                    backgroundColor: 'rgba(18, 76, 114, 0.03)'
                  }}>
                    <span className="text-gray-800 text-sm font-medium">
                      {hiringManagers.find(manager => Number(manager.user_id) === Number(selectedRequest.hiring_manager))?.first_name}
                    </span>
                  </div>
                )}
              </div>

              {/* Planned Start Date */}
              <div className="space-y-1">
                <label className="block text-xs sm:text-sm font-medium" style={{ color: 'rgb(18, 76, 114)' }}>
                  Planned Start Date
                </label>
                {(isEditMode || isPlanDate) ? (
                  <input
                    type="date"
                    className="w-full px-2 sm:px-3 py-1.5 sm:py-2 border rounded-lg outline-none transition text-sm text-gray-700"
                    style={{ 
                      borderColor: 'rgba(18, 76, 114, 0.3)',
                      backgroundColor: 'white'
                    }}
                    onFocus={(e) => {
                      e.target.style.boxShadow = '0 0 0 2px rgba(18, 76, 114, 0.2)';
                      e.target.style.borderColor = 'rgb(18, 76, 114)';
                    }}
                    onBlur={(e) => {
                      e.target.style.boxShadow = 'none';
                      e.target.style.borderColor = 'rgba(18, 76, 114, 0.3)';
                    }}
                    value={selectedRequest.planned_start_date ? selectedRequest.planned_start_date.split('T')[0] : ''}
                    onChange={(e) =>
                      setSelectedRequest({ ...selectedRequest, planned_start_date: e.target.value })
                    }
                  />
                ) : (
                  <div className="px-2 sm:px-3 py-1.5 sm:py-2 border rounded-lg" style={{ 
                    borderColor: 'rgba(18, 76, 114, 0.2)',
                    backgroundColor: 'rgba(18, 76, 114, 0.03)'
                  }}>
                    <span className="text-gray-800 text-sm font-medium">
                      {selectedRequest.planned_start_date ? new Date(selectedRequest.planned_start_date).toLocaleDateString() : 'N/A'}
                    </span>
                  </div>
                )}
              </div>

              {/* Priority */}
              <div className="space-y-1">
                <label className="block text-xs sm:text-sm font-medium" style={{ color: 'rgb(18, 76, 114)' }}>
                  Priority
                </label>
                {isEditMode ? (
                  <select
                    className="w-full px-2 sm:px-3 py-1.5 sm:py-2 border rounded-lg outline-none transition text-sm text-gray-700"
                    style={{ 
                      borderColor: 'rgba(18, 76, 114, 0.3)',
                      backgroundColor: 'white'
                    }}
                    onFocus={(e) => {
                      e.target.style.boxShadow = '0 0 0 2px rgba(18, 76, 114, 0.2)';
                      e.target.style.borderColor = 'rgb(18, 76, 114)';
                    }}
                    onBlur={(e) => {
                      e.target.style.boxShadow = 'none';
                      e.target.style.borderColor = 'rgba(18, 76, 114, 0.3)';
                    }}
                    value={selectedRequest.priority}
                    onChange={(e) => setSelectedRequest({ ...selectedRequest, priority: e.target.value })}
                  >
                    <option value="Low">Low</option>
                    <option value="Medium">Medium</option>
                    <option value="High">High</option>
                  </select>
                ) : (
                  <div className="px-2 sm:px-3 py-1.5 sm:py-2 border rounded-lg" style={{ 
                    borderColor: 'rgba(18, 76, 114, 0.2)',
                    backgroundColor: 'rgba(18, 76, 114, 0.03)'
                  }}>
                    <span className="text-gray-800 text-sm font-medium">{selectedRequest.priority}</span>
                  </div>
                )}
              </div>

              {/* Hiring Type */}
              <div className="space-y-1">
                <label className="block text-xs sm:text-sm font-medium" style={{ color: 'rgb(18, 76, 114)' }}>
                  Hiring Type
                </label>
                {isEditMode ? (
                  <select
                    className="w-full px-2 sm:px-3 py-1.5 sm:py-2 border rounded-lg outline-none transition text-sm text-gray-700"
                    style={{ 
                      borderColor: 'rgba(18, 76, 114, 0.3)',
                      backgroundColor: 'white'
                    }}
                    onFocus={(e) => {
                      e.target.style.boxShadow = '0 0 0 2px rgba(18, 76, 114, 0.2)';
                      e.target.style.borderColor = 'rgb(18, 76, 114)';
                    }}
                    onBlur={(e) => {
                      e.target.style.boxShadow = 'none';
                      e.target.style.borderColor = 'rgba(18, 76, 114, 0.3)';
                    }}
                    value={selectedRequest.hiring_Type}
                    onChange={(e) => setSelectedRequest({ ...selectedRequest, hiring_Type: e.target.value })}
                  >
                    <option value="">Select Hiring Type</option>
                    <option value="New">New</option>
                    {selectedRequest.request_type === "Exceptional" && <option value="Replacement">Replacement</option>}
                  </select>
                ) : (
                  <div className="px-2 sm:px-3 py-1.5 sm:py-2 border rounded-lg" style={{ 
                    borderColor: 'rgba(18, 76, 114, 0.2)',
                    backgroundColor: 'rgba(18, 76, 114, 0.03)'
                  }}>
                    <span className="text-gray-800 text-sm font-medium">{selectedRequest.hiring_Type}</span>
                  </div>
                )}
              </div>

              {/* Full Width Fields */}
              {/* Reason for Hire */}
              <div className="col-span-1 md:col-span-3 space-y-1 mt-2">
                <label className="block text-xs sm:text-sm font-medium" style={{ color: 'rgb(18, 76, 114)' }}>
                  Reason for Hire
                </label>
                {isEditMode ? (
                  <textarea
                    className="w-full px-2 sm:px-3 py-1.5 sm:py-2 border rounded-lg outline-none transition text-sm text-gray-700"
                    style={{ 
                      borderColor: 'rgba(18, 76, 114, 0.3)',
                      backgroundColor: 'white',
                      minHeight: '60px',
                      resize: 'vertical'
                    }}
                    onFocus={(e) => {
                      e.target.style.boxShadow = '0 0 0 2px rgba(18, 76, 114, 0.2)';
                      e.target.style.borderColor = 'rgb(18, 76, 114)';
                    }}
                    onBlur={(e) => {
                      e.target.style.boxShadow = 'none';
                      e.target.style.borderColor = 'rgba(18, 76, 114, 0.3)';
                    }}
                    value={selectedRequest.reason_for_hire}
                    onChange={(e) =>
                      setSelectedRequest({ ...selectedRequest, reason_for_hire: e.target.value })
                    }
                  />
                ) : (
                  <div className="px-2 sm:px-3 py-1.5 sm:py-2 border rounded-lg" style={{ 
                    borderColor: 'rgba(18, 76, 114, 0.2)',
                    backgroundColor: 'rgba(18, 76, 114, 0.03)'
                  }}>
                    <p className="text-gray-800 text-sm font-medium whitespace-pre-line">{selectedRequest.reason_for_hire}</p>
                  </div>
                )}
              </div>

              {/* Preferred Requirement */}
              {selectedRequest.request_type === "Exceptional" && (
                <div className="col-span-1 md:col-span-3 space-y-1 mt-2">
                  <label className="block text-xs sm:text-sm font-medium" style={{ color: 'rgb(18, 76, 114)' }}>
                    Preferred Requirement
                  </label>
                  {isEditMode ? (
                    <textarea
                      className="w-full px-2 sm:px-3 py-1.5 sm:py-2 border rounded-lg outline-none transition text-sm text-gray-700"
                      style={{ 
                        borderColor: 'rgba(18, 76, 114, 0.3)',
                        backgroundColor: 'white',
                        minHeight: '60px',
                        resize: 'vertical'
                      }}
                      onFocus={(e) => {
                        e.target.style.boxShadow = '0 0 0 2px rgba(18, 76, 114, 0.2)';
                        e.target.style.borderColor = 'rgb(18, 76, 114)';
                      }}
                      onBlur={(e) => {
                        e.target.style.boxShadow = 'none';
                        e.target.style.borderColor = 'rgba(18, 76, 114, 0.3)';
                      }}
                      value={selectedRequest.preferred_requirment}
                      onChange={(e) =>
                        setSelectedRequest({ ...selectedRequest, preferred_requirment: e.target.value })
                      }
                    />
                  ) : (
                    <div className="px-2 sm:px-3 py-1.5 sm:py-2 border rounded-lg" style={{ 
                      borderColor: 'rgba(18, 76, 114, 0.2)',
                      backgroundColor: 'rgba(18, 76, 114, 0.03)'
                    }}>
                      <p className="text-gray-800 text-sm font-medium whitespace-pre-line">{selectedRequest.preferred_requirment}</p>
                    </div>
                  )}
                </div>
              )}

              {/* Notes */}
              {(isSendApproveMode || isApproveMode || IsRejecMode || isHoldMode || isUnHoldMode) && (
                <div className="col-span-1 md:col-span-3 space-y-1 mt-2">
                  <label className="block text-xs sm:text-sm font-medium" style={{ color: 'rgb(18, 76, 114)' }}>
                    Notes
                  </label>
                  <textarea
                    className="w-full px-2 sm:px-3 py-1.5 sm:py-2 border rounded-lg outline-none transition text-sm text-gray-700"
                    style={{ 
                      borderColor: 'rgba(18, 76, 114, 0.3)',
                      backgroundColor: 'white',
                      minHeight: '60px',
                      resize: 'vertical'
                    }}
                    onFocus={(e) => {
                      e.target.style.boxShadow = '0 0 0 2px rgba(18, 76, 114, 0.2)';
                      e.target.style.borderColor = 'rgb(18, 76, 114)';
                    }}
                    onBlur={(e) => {
                      e.target.style.boxShadow = 'none';
                      e.target.style.borderColor = 'rgba(18, 76, 114, 0.3)';
                    }}
                    value={selectedRequest.notes}
                    onChange={(e) =>
                      setSelectedRequest({ ...selectedRequest, notes: e.target.value })
                    }
                    placeholder="Add your notes here..."
                  />
                </div>
              )}
            </div>
          )}

          {activeTab === 'jd' && (
            <div className="pt-3">
              <JobDescription
                activeTab={activeTab}
                selectedRequest={selectedRequest.request_type === "Exceptional" ? selectedRequest : {
                  ...DemandPlanning.find(d => Number(d.demand_id) === Number(selectedRequest.demand_id)),
                  request_id: selectedRequest?.demand_id
                }}
                isEditMode={isEditMode}
                currentDocument={currentDocument || selectedRequest?.Documents}
                processtype={selectedRequest.request_type === "Exceptional" ? "JobDescription" : "ForeCastJobDescription"}
                onDelete={(doc) => setCurrentDocument(null)}
                onUpload={(file) => setCurrentDocument(file)}
              />
            </div>
          )}
        </div>
      </div>

      {/* Modal Footer - Fixed height */}
      <div className="flex-shrink-0 flex flex-col sm:flex-row justify-end gap-2 p-4 sm:p-6 border-t rounded-b-2xl" style={{ 
        borderColor: 'rgba(18, 76, 114, 0.1)',
        background: 'linear-gradient(to right, transparent, rgba(18, 76, 114, 0.05))',
        minHeight: '76px'
      }}>
        <button
          onClick={closeModal}
          className="px-4 py-2 text-sm bg-white border rounded-lg transition-all font-medium"
          style={{ 
            color: 'rgb(18, 76, 114)',
            borderColor: 'rgba(18, 76, 114, 0.3)'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = 'rgba(18, 76, 114, 0.1)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = 'white';
          }}
        >
          Cancel
        </button>

        {(isEditMode || isPlanDate) && (
          <button
            onClick={handleEditSave}
            disabled={isSubmitting}
            className="px-4 py-2 text-sm text-white font-medium rounded-lg transition-all"
            style={{ 
              backgroundColor: 'rgb(18, 76, 114)',
              cursor: isSubmitting ? 'not-allowed' : 'pointer',
              opacity: isSubmitting ? 0.7 : 1,
              boxShadow: '0 4px 6px -1px rgba(18, 76, 114, 0.2)'
            }}
            onMouseEnter={(e) => {
              if (!isSubmitting) {
                e.currentTarget.style.backgroundColor = 'rgba(18, 76, 114, 0.9)';
              }
            }}
            onMouseLeave={(e) => {
              if (!isSubmitting) {
                e.currentTarget.style.backgroundColor = 'rgb(18, 76, 114)';
              }
            }}
          >
            {isSubmitting ? 'Saving...' : 'Save'}
          </button>
        )}

        {isApproveMode && (
          <button
            onClick={handleSaveApprove}
            disabled={isApproving}
            className="px-4 py-2 text-sm text-white font-medium rounded-lg transition-all"
            style={{ 
              backgroundColor: 'rgb(34, 139, 34)',
              cursor: isApproving ? 'not-allowed' : 'pointer',
              opacity: isApproving ? 0.7 : 1,
              boxShadow: '0 4px 6px -1px rgba(34, 139, 34, 0.2)'
            }}
            onMouseEnter={(e) => {
              if (!isApproving) {
                e.currentTarget.style.backgroundColor = 'rgba(34, 139, 34, 0.9)';
              }
            }}
            onMouseLeave={(e) => {
              if (!isApproving) {
                e.currentTarget.style.backgroundColor = 'rgb(34, 139, 34)';
              }
            }}
          >
            {isApproving ? 'Approving...' : 'Approve'}
          </button>
        )}

        {isSendApproveMode && (
          <button
            onClick={handleSaveSendApprove}
            disabled={isSubmitting}
            className="px-4 py-2 text-sm text-white font-medium rounded-lg transition-all"
            style={{ 
              backgroundColor: 'rgb(18, 76, 114)',
              cursor: isSubmitting ? 'not-allowed' : 'pointer',
              opacity: isSubmitting ? 0.7 : 1,
              boxShadow: '0 4px 6px -1px rgba(18, 76, 114, 0.2)'
            }}
            onMouseEnter={(e) => {
              if (!isSubmitting) {
                e.currentTarget.style.backgroundColor = 'rgba(18, 76, 114, 0.9)';
              }
            }}
            onMouseLeave={(e) => {
              if (!isSubmitting) {
                e.currentTarget.style.backgroundColor = 'rgb(18, 76, 114)';
              }
            }}
          >
            {isSubmitting ? 'Sending...' : 'Send for Approval'}
          </button>
        )}

        {isHoldMode && (
          <button
            onClick={handleSaveHold}
            disabled={isSubmitting}
            className="px-4 py-2 text-sm text-white font-medium rounded-lg transition-all"
            style={{ 
              backgroundColor: 'rgb(245, 158, 11)',
              cursor: isSubmitting ? 'not-allowed' : 'pointer',
              opacity: isSubmitting ? 0.7 : 1,
              boxShadow: '0 4px 6px -1px rgba(245, 158, 11, 0.2)'
            }}
            onMouseEnter={(e) => {
              if (!isSubmitting) {
                e.currentTarget.style.backgroundColor = 'rgba(245, 158, 11, 0.9)';
              }
            }}
            onMouseLeave={(e) => {
              if (!isSubmitting) {
                e.currentTarget.style.backgroundColor = 'rgb(245, 158, 11)';
              }
            }}
          >
            {isSubmitting ? 'Holding...' : 'Hold'}
          </button>
        )}

        {isUnHoldMode && (
          <button
            onClick={handleSaveUnHold}
            disabled={isSubmitting}
            className="px-4 py-2 text-sm text-white font-medium rounded-lg transition-all"
            style={{ 
              backgroundColor: 'rgb(59, 130, 246)',
              cursor: isSubmitting ? 'not-allowed' : 'pointer',
              opacity: isSubmitting ? 0.7 : 1,
              boxShadow: '0 4px 6px -1px rgba(59, 130, 246, 0.2)'
            }}
            onMouseEnter={(e) => {
              if (!isSubmitting) {
                e.currentTarget.style.backgroundColor = 'rgba(59, 130, 246, 0.9)';
              }
            }}
            onMouseLeave={(e) => {
              if (!isSubmitting) {
                e.currentTarget.style.backgroundColor = 'rgb(59, 130, 246)';
              }
            }}
          >
            {isSubmitting ? 'Unholding...' : 'Unhold'}
          </button>
        )}

        {IsRejecMode && (
          <button
            onClick={handleRejectSave}
            disabled={isSubmitting}
            className="px-4 py-2 text-sm text-white font-medium rounded-lg transition-all"
            style={{ 
              backgroundColor: 'rgb(220, 38, 38)',
              cursor: isSubmitting ? 'not-allowed' : 'pointer',
              opacity: isSubmitting ? 0.7 : 1,
              boxShadow: '0 4px 6px -1px rgba(220, 38, 38, 0.2)'
            }}
            onMouseEnter={(e) => {
              if (!isSubmitting) {
                e.currentTarget.style.backgroundColor = 'rgba(220, 38, 38, 0.9)';
              }
            }}
            onMouseLeave={(e) => {
              if (!isSubmitting) {
                e.currentTarget.style.backgroundColor = 'rgb(220, 38, 38)';
              }
            }}
          >
            {isSubmitting ? 'Rejecting...' : 'Reject'}
          </button>
        )}
      </div>
    </div>
  </div>
)}
 {isConfrimModalVisible && (
  <div className="fixed inset-0 backdrop-blur-sm flex justify-center items-center p-4 z-50" style={{ backgroundColor: 'rgba(18, 76, 114, 0.15)' }}>
    <div 
      className="relative bg-white rounded-2xl shadow-2xl w-full max-w-md mx-auto"
      style={{ 
        borderColor: 'rgba(18, 76, 114, 0.15)', 
        borderWidth: '1px',
        boxShadow: '0 20px 40px -15px rgba(18, 76, 114, 0.25)'
      }}
    >
      {/* Modal Header */}
      <div className="flex items-center justify-between p-5 sm:p-6 border-b" style={{ 
        borderColor: 'rgba(18, 76, 114, 0.08)'
      }}>
        <div className="flex items-center gap-3">
          <div className="p-2 rounded-lg" style={{ backgroundColor: 'rgba(18, 76, 114, 0.05)' }}>
            <svg className="w-5 h-5" style={{ color: 'rgba(18, 76, 114)' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
            </svg>
          </div>
          <h2 className="text-lg sm:text-xl font-semibold" style={{ color: 'rgb(18, 76, 114)' }}>
            Convert to Sourcing
          </h2>
        </div>
        <button 
          onClick={handleCancel}
          className="flex-shrink-0 p-1.5 rounded-lg transition-all duration-200 hover:scale-105"
          style={{ 
            color: 'rgba(18, 76, 114, 0.5)',
            backgroundColor: 'rgba(18, 76, 114, 0.05)'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = 'rgba(18, 76, 114, 0.1)';
            e.currentTarget.style.color = 'rgb(18, 76, 114)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = 'rgba(18, 76, 114, 0.05)';
            e.currentTarget.style.color = 'rgba(18, 76, 114, 0.5)';
          }}
          aria-label="Close"
        >
          <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      {/* Modal Body */}
      <div className="p-5 sm:p-6 space-y-6">
        {/* Main Confirmation Message */}
        <div className="text-center">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full mb-3" style={{ backgroundColor: 'rgba(18, 76, 114, 0.05)' }}>
            <svg className="w-6 h-6" style={{ color: 'rgba(18, 76, 114)' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
            </svg>
          </div>
          
          <h3 className="text-base sm:text-lg font-semibold mb-2" style={{ color: 'rgb(18, 76, 114)' }}>
            Ready to proceed with sourcing?
          </h3>
          
          <p className="text-sm text-gray-600 mb-3">
            This will assign the request to a recruiter and enable candidate uploads.
          </p>
          
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full" style={{ 
            backgroundColor: 'rgba(18, 76, 114, 0.05)',
            border: '1px solid rgba(18, 76, 114, 0.1)'
          }}>
            <span className="text-xs font-medium" style={{ color: 'rgba(18, 76, 114, 0.7)' }}>Request ID:</span>
            <span className="text-sm font-semibold" style={{ color: 'rgb(18, 76, 114)' }}>
              {selectedRequest?.referenceNumber || 'N/A'}
            </span>
          </div>
        </div>

        {/* Divider with "Assign to recruiter" text */}
        <div className="relative">
          <div className="absolute inset-0 flex items-center">
            <div className="w-full border-t" style={{ borderColor: 'rgba(18, 76, 114, 0.1)' }}></div>
          </div>
          <div className="relative flex justify-center">
            <span className="px-3 bg-white text-sm font-medium" style={{ color: 'rgb(18, 76, 114)' }}>
              Assign to recruiter
            </span>
          </div>
        </div>

        {/* Recruiter Selection */}
        <div className="space-y-2.5">
          <div className="flex items-center justify-between">
            <label className="block text-sm font-medium" style={{ color: 'rgb(18, 76, 114)' }}>
              Select Recruiter
            </label>
            <span className="text-xs px-2 py-0.5 rounded-full" style={{ 
              backgroundColor: errors.recruiter ? 'rgba(239, 68, 68, 0.1)' : 'rgba(18, 76, 114, 0.1)',
              color: errors.recruiter ? '#ef4444' : 'rgb(18, 76, 114)'
            }}>
              {errors.recruiter ? 'Required' : 'Required'}
            </span>
          </div>
          
          <Select
            className="basic-single"
            classNamePrefix="select"
            options={hiringManagers
              .filter((manager) =>
                manager.userCompanies?.some?.(uc => uc.role === "HR Specialist") ||
                manager.role === "HR Specialist"
              )
              .map((manager) => ({
                value: manager.user_id,
                label: `${manager.first_name} ${manager.last_name}`,
                email: manager.email
              }))}
            value={
              selectedRecruiter
                ? {
                    value: selectedRecruiter,
                    label: `${
                      hiringManagers.find((m) => m.user_id === selectedRecruiter)?.first_name
                    } ${
                      hiringManagers.find((m) => m.user_id === selectedRecruiter)?.last_name
                    }`,
                  }
                : null
            }
            onChange={handleRecruiterChange}
            placeholder="Search recruiter..."
            isSearchable
            styles={{
              control: (base, { isFocused }) => ({
                ...base,
                borderColor: errors.recruiter 
                  ? '#ef4444'
                  : isFocused
                  ? 'rgb(18, 76, 114)'
                  : 'rgba(18, 76, 114, 0.2)',
                boxShadow: isFocused && !errors.recruiter 
                  ? '0 0 0 3px rgba(18, 76, 114, 0.1)'
                  : errors.recruiter
                  ? '0 0 0 3px rgba(239, 68, 68, 0.1)'
                  : 'none',
                '&:hover': {
                  borderColor: errors.recruiter 
                    ? '#ef4444'
                    : 'rgba(18, 76, 114, 0.4)',
                },
                minHeight: '46px',
                borderRadius: '10px',
                padding: '2px 8px',
                transition: 'all 0.2s ease',
                fontSize: '14px',
              }),
              option: (base, { isFocused, isSelected }) => ({
                ...base,
                backgroundColor: isSelected
                  ? 'rgb(18, 76, 114)'
                  : isFocused
                  ? 'rgba(18, 76, 114, 0.08)'
                  : 'white',
                color: isSelected ? 'white' : 'rgb(18, 76, 114)',
                fontSize: '14px',
                padding: '10px 12px',
                borderRadius: '6px',
                margin: '2px 4px',
                '&:active': {
                  backgroundColor: 'rgba(18, 76, 114, 0.15)',
                },
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
              }),
              placeholder: (base) => ({
                ...base,
                color: 'rgba(18, 76, 114, 0.5)',
                fontSize: '14px',
              }),
              menu: (base) => ({
                ...base,
                border: '1px solid rgba(18, 76, 114, 0.1)',
                boxShadow: '0 10px 25px -5px rgba(18, 76, 114, 0.15)',
                borderRadius: '10px',
                marginTop: '6px',
                padding: '4px',
                zIndex: 9999,
              }),
              menuList: (base) => ({
                ...base,
                padding: '4px',
              }),
              dropdownIndicator: (base) => ({
                ...base,
                color: 'rgba(18, 76, 114, 0.5)',
                padding: '0 4px',
                '&:hover': {
                  color: 'rgb(18, 76, 114)',
                },
              }),
              indicatorSeparator: (base) => ({
                ...base,
                backgroundColor: 'rgba(18, 76, 114, 0.15)',
              }),
              singleValue: (base) => ({
                ...base,
                color: 'rgb(18, 76, 114)',
                fontSize: '14px',
                fontWeight: '500',
              }),
              input: (base) => ({
                ...base,
                color: 'rgb(18, 76, 114)',
              }),
            }}
            formatOptionLabel={({ label, email }) => (
              <div className="flex flex-col">
                <span className="font-medium">{label}</span>
                {email && (
                  <span className="text-xs text-gray-500 truncate">{email}</span>
                )}
              </div>
            )}
          />
          
          {errors.recruiter && (
            <div className="flex items-center gap-1.5 mt-1 px-3 py-2 rounded-lg" style={{ 
              backgroundColor: 'rgba(239, 68, 68, 0.05)',
              border: '1px solid rgba(239, 68, 68, 0.2)'
            }}>
              <svg className="w-4 h-4 flex-shrink-0" style={{ color: 'rgb(239, 68, 68)' }} fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
              </svg>
              <span className="text-xs" style={{ color: 'rgb(239, 68, 68)' }}>{errors.recruiter}</span>
            </div>
          )}
          
          {/* Helper Text */}
          {selectedRecruiter && (
            <div className="flex items-center gap-2 text-xs p-3 rounded-lg" style={{ 
              backgroundColor: 'rgba(18, 76, 114, 0.03)',
              border: '1px dashed rgba(18, 76, 114, 0.1)'
            }}>
              <svg className="w-4 h-4 flex-shrink-0" style={{ color: 'rgba(18, 76, 114, 0.6)' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
              </svg>
              <span style={{ color: 'rgba(18, 76, 114, 0.7)' }}>
                <span className="font-medium" style={{ color: 'rgb(18, 76, 114)' }}>
                  {hiringManagers.find(m => m.user_id === selectedRecruiter)?.first_name}{" "}
                  {hiringManagers.find(m => m.user_id === selectedRecruiter)?.last_name}
                </span> will receive notification and begin candidate sourcing
              </span>
            </div>
          )}
        </div>

        {/* Process Information */}
        <div className="p-4 rounded-xl" style={{ 
          backgroundColor: 'rgba(18, 76, 114, 0.05)', 
          border: '1px solid rgba(18, 76, 114, 0.05)'
        }}>
          <div className="flex items-center gap-2 mb-2">
            <svg className="w-4 h-4" style={{ color: 'rgba(18, 76, 114)' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <span className="text-xs font-medium" style={{ color: 'rgba(18, 76, 114)' }}>What happens next?</span>
          </div>
          <ul className="space-y-1.5">
            <li className="flex items-start gap-2">
              <div className="w-1.5 h-1.5 rounded-full mt-1 flex-shrink-0" style={{ backgroundColor: 'rgba(18, 76, 114)' }}></div>
              <span className="text-xs" style={{ color: 'rgba(18, 76, 114)' }}>
                Request status changes to "Sourcing"
              </span>
            </li>
            <li className="flex items-start gap-2">
              <div className="w-1.5 h-1.5 rounded-full mt-1 flex-shrink-0" style={{ backgroundColor: 'rgba(18, 76, 114)' }}></div>
              <span className="text-xs" style={{ color: 'rgba(18, 76, 114)' }}>
                Recruiter can start uploading and screening candidates
              </span>
            </li>
            <li className="flex items-start gap-2">
              <div className="w-1.5 h-1.5 rounded-full mt-1 flex-shrink-0" style={{ backgroundColor: 'rgba(18, 76, 114)' }}></div>
              <span className="text-xs" style={{ color: 'rgba(18, 76, 114)' }}>
                You can track progress in the Sourcing section
              </span>
            </li>
          </ul>
        </div>
      </div>

      {/* Modal Footer */}
      <div className="flex flex-col sm:flex-row gap-3 p-5 sm:p-6 border-t rounded-b-2xl" style={{ 
        borderColor: 'rgba(18, 76, 114, 0.08)',
        backgroundColor: 'rgba(18, 76, 114, 0.02)'
      }}>
        <button
          onClick={handleCancel}
          className="flex-1 px-4 py-3 bg-white border rounded-xl transition-all duration-200 font-medium hover:shadow-sm"
          style={{ 
            color: 'rgb(18, 76, 114)',
            borderColor: 'rgba(18, 76, 114, 0.2)'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = 'rgba(18, 76, 114, 0.05)';
            e.currentTarget.style.borderColor = 'rgba(18, 76, 114, 0.3)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = 'white';
            e.currentTarget.style.borderColor = 'rgba(18, 76, 114, 0.2)';
          }}
        >
          Cancel
        </button>
        <button
          onClick={handleConfirm}
          disabled={isSubmitting || !selectedRecruiter}
          className="flex-1 px-4 py-3 text-white font-medium rounded-xl transition-all duration-200 relative overflow-hidden group"
          style={{ 
            backgroundColor: !selectedRecruiter || isSubmitting 
              ? 'rgba(168, 85, 247, 0.5)' 
              :   'rgba(18, 76, 114)',
            cursor: !selectedRecruiter || isSubmitting 
              ? 'not-allowed' 
              : 'pointer',
            boxShadow: !selectedRecruiter || isSubmitting 
              ? 'none' 
              : '0 4px 15px -3px rgba(168, 85, 247, 0.25)'
          }}
          onMouseEnter={(e) => {
            if (selectedRecruiter && !isSubmitting) {
              e.currentTarget.style.boxShadow = '0 6px 20px -3px rgba(168, 85, 247, 0.35)';
              e.currentTarget.style.transform = 'translateY(-1px)';
            }
          }}
          onMouseLeave={(e) => {
            if (selectedRecruiter && !isSubmitting) {
              e.currentTarget.style.boxShadow = '0 4px 15px -3px rgba(168, 85, 247, 0.25)';
              e.currentTarget.style.transform = 'translateY(0)';
            }
          }}
        >
          <span className="relative z-10 flex items-center justify-center gap-2">
            {isSubmitting ? (
              <>
                <svg className="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Converting...
              </>
            ) : (
              <>
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                </svg>
                Confirm & Convert
              </>
            )}
          </span>
          {selectedRecruiter && !isSubmitting && (
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 -translate-x-full group-hover:translate-x-full"></div>
          )}
        </button>
      </div>
    </div>
  </div>
)}

 <CreateHiringRequestModal
        isOpen={isCreateModalOpen}
        onClose={() => setIsCreateModalOpen(false)}
        onSuccess={handleRequestCreated}
      />
         {/* <footer className="w-full bg-[#f5f3ef] text-primary-600 py-4 px-6 mt-auto shadow-inner mt-6">
  <div className="flex flex-col md:flex-row justify-between items-center text-sm">
    <span className="mb-2 md:mb-0">&copy; {new Date().getFullYear()} Digital & Transformation Department. All rights reserved.</span>
    <div className="flex space-x-4">
      <a   className="hover:underline">Privacy Policy</a>
      <a   className="hover:underline">Terms of Service</a>
    </div>
  </div>
</footer> */}
    
</div>
 </>
 
  );
};

export default HiringPage;
